var activateLicensekey, activateVector, addLocationQuestion, addLocationQuestionDisplay, addPOI, addPartOf, addRow, applySavedTemplate, cancelAddPOI, changeDataAuto, changeDatabase, changeReportUI, changedChartType, changedColumnQuestion, changedFormType, changedRowQuestion, checkKey, clearDates, createQuestionDisplay, createTableQuestion, deletePOI, deleteSavedTemplate, downloadJasperReport, downloadReport, editReportTemplate, editSavedTemplate, getQuestionValue, getQuestionValues, handleError, imageSelected, jsontextsubq, limitrange, listenerAdded, loadSavedReports, loadSavedSession, modified, openAinsDialog, questionDeSelected, questionSelected, reportTableQuestions, saveReportTemplate, saveTableInstance, selectQuestion, setEditableTableQuestion, showActivateLicense, showInstanceMap, showQuickGuideSlide, showSubgroupField, toggleDatabase, toggleLegendTable, validateData;

window.drawControls = {};

window.emap = void 0;

window.vectorLayer = void 0;

window.current_point = null;

window.imageQuestion = [];

window.current_partOf = null;

window.callPartOf = false;

window.datePickerCountPartOf = null;

window.datePickerCount = 0;

window.filesUploaded = 0;

window.isprev = false;

window.uploadTables = [];

jsontextsubq = null;

showInstanceMap = function() {
  $('a[href="#tabs-3"]').tab("show");
  if ((typeof emap !== "undefined" && emap !== null) && (emap.map.invalidateSize != null)) {
    return emap.map.invalidateSize();
  }
};

modified = function(event, id) {};


/*
This function creates a map in the div given for the poi_id given


div_id is the id of the div to create the map in
poi_id is left empty in the new backbone way of doing things
model is the model for the answer
 */


/*
Get Selected Components and load the data
 */

loadSavedSession = function(poiTypes, locs, users, dates) {
  var dt, i, loc, node, pois;
  if (poiTypes !== "" && poiTypes !== undefined) {
    pois = poiTypes.split(",");
    i = 0;
    while (i < pois.length) {
      if (document.getElementById("poi" + pois[i]) != null) {
        document.getElementById("poi" + pois[i]).checked = true;
        $("#poi" + pois[i]).trigger("change");
        LoadContent(pois[i]);
      }
      i++;
    }
    if (locs && locs !== "") {
      loc = locs.split(",");
      i = 0;
      while (i < loc.length) {
        node = $("#tree").dynatree("getTree").getNodeByKey(loc[i]);
        if (node) {
          node.select(true);
        }
        i++;
      }
    }
    if (users !== "" && users !== undefined) {
      users = users.split(",");
      i = 0;
      while (i < users.length) {
        if (document.getElementById("user" + users[i]) != null) {
          document.getElementById("user" + users[i]).checked = true;
          us_checked[users[i]] = true;
        }
        i++;
      }
    }
    if (dates !== "" && dates !== undefined) {
      dt = dates.split(";");
      document.getElementById("from").value = dt[0];
      document.getElementById("to").value = dt[1];
    }
    if (((users !== "" && users !== undefined) || (dates !== "" && dates !== undefined)) && (poiTypes !== "" && poiTypes !== undefined)) {
      $("#tabView").html("");
      return filterData();
    }
  }
};

changeDataAuto = function(evt) {
  var loadDataAutomatically;
  if (evt.currentTarget.checked) {
    $(".autoload").each(function(i, el) {
      return $(el).prop("checked", "checked");
    });
    loadDataAutomatically = true;
    return window.clientPersistModel.save({
      "showDataAutomatically": true
    });
  } else {
    $(".autoload").each(function(i, el) {
      return $(el).prop("checked", "");
    });
    loadDataAutomatically = false;
    return window.clientPersistModel.save({
      "showDataAutomatically": false
    });
  }
};

$('.autoload').on("change", changeDataAuto);

addLocationQuestion = function(question, editing, id) {
  var k, l, label, len, len1, len2, len3, location, m, n, options, ref, ref1, ref2, ref3, response, scount, user_level;
  label = "";
  user_level = -1;
  if (question.id === "Location1") {
    if (window.locationLabels[0]) {
      label = window.locationLabels[0];
    } else {
      label = question.text;
    }
    user_level = 0;
  } else if (question.id === "Location2") {
    if (window.locationLabels[1]) {
      label = window.locationLabels[1];
    } else {
      label = question.text;
    }
    user_level = 1;
  } else if (question.id === "Location3") {
    if (window.locationLabels[2]) {
      label = window.locationLabels[2];
    } else {
      label = question.text;
    }
    user_level = 2;
  } else if (question.id === "Location4") {
    if (window.locationLabels[3]) {
      label = window.locationLabels[3];
    } else {
      label = question.text;
    }
    user_level = 3;
  }
  scount = 0;
  ref = window.locations;
  for (k = 0, len = ref.length; k < len; k++) {
    location = ref[k];
    if (Number(location.level) === user_level) {
      if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
        scount += 1;
      }
    }
  }
  if ((scount === 0) || (user_level <= level[0] && !editing && window.location_id.length <= 1)) {
    return "";
  }
  options = "";
  if (db === "poimapper" && user_level === 0) {
    ref1 = window.locations;
    for (l = 0, len1 = ref1.length; l < len1; l++) {
      location = ref1[l];
      if (Number(location.level) === user_level) {
        if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
          options += "<option value=\"" + location.key + "\">" + location.title + "</option>";
        }
      }
    }
  } else if ((user_level === Number(level[0]) && window.location_id.length > 1) || (user_level >= Number(level[0]) && window.location_id.length <= 1)) {
    ref2 = window.locations;
    for (m = 0, len2 = ref2.length; m < len2; m++) {
      location = ref2[m];
      if (Number(location.level) === user_level) {
        if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
          options += "<option value=\"" + location.key + "\">" + location.title + "</option>";
        }
      }
    }
  } else if (user_level > Number(level[0])) {
    if (window.isprev) {
      ref3 = window.locations;
      for (n = 0, len3 = ref3.length; n < len3; n++) {
        location = ref3[n];
        if (Number(location.level) === user_level) {
          if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
            options += "<option value=\"" + location.key + "\">" + location.title + "</option>";
          }
        }
      }
    }
  }
  response = "<div id=\"question_" + question.id + "\" class=\"form-group\">\n    <label id=\"label" + question.id + "\">" + label + "</label>\n    <select id=\"" + question.id + "_" + id + "\" class=\"form-control\" name=\"" + question.id + "\" onchange=\"locationChanged('" + question.id + "', '" + user_level + "', '" + id + "')\" >\n        <option value=\"NULL\" >\n            Select One\n        </option>\n        " + options + "\n    </select>\n</div>";
  return response;
};

addLocationQuestionDisplay = function(question, formNo, id) {
  var k, l, label, len, len1, len2, location, m, options, ref, ref1, ref2, response, scount, user_level;
  user_level = -1;
  label = "";
  if (question.id === "Location1") {
    if (window.locationLabels[0]) {
      label = window.locationLabels[0];
    } else {
      label = question.text;
    }
    user_level = 0;
  } else if (question.id === "Location2") {
    if (window.locationLabels[1]) {
      label = window.locationLabels[1];
    } else {
      label = question.text;
    }
    user_level = 1;
  } else if (question.id === "Location3") {
    if (window.locationLabels[2]) {
      label = window.locationLabels[2];
    } else {
      label = question.text;
    }
    user_level = 2;
  } else if (question.id === "Location4") {
    if (window.locationLabels[3]) {
      label = window.locationLabels[3];
    } else {
      label = question.text;
    }
    user_level = 3;
  }
  scount = 0;
  ref = window.locations;
  for (k = 0, len = ref.length; k < len; k++) {
    location = ref[k];
    if (Number(location.level) === user_level) {
      if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
        scount += 1;
      }
    }
  }
  if ((scount === 0) || (user_level <= level[0] && window.location_id.length <= 1)) {
    return "";
  }
  options = "";
  if (db === "poimapper" && user_level === 0) {
    ref1 = window.locations;
    for (l = 0, len1 = ref1.length; l < len1; l++) {
      location = ref1[l];
      if (Number(location.level) === user_level) {
        if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
          if (location.title === question.ans[formNo]) {
            options += "<option value=\"" + location.key + "\" selected=true>" + location.title + "</option>";
          } else {
            options += "<option value=\"" + location.key + "\">" + location.title + "</option>";
          }
        }
      }
    }
  } else {
    ref2 = window.locations;
    for (m = 0, len2 = ref2.length; m < len2; m++) {
      location = ref2[m];
      if (Number(location.level) === user_level) {
        if (!(user_level === (level[0] + 1) && !existsInArray(window.location_id, location.parent))) {
          if (location.title === question.ans[formNo]) {
            options += "<option value=\"" + location.key + "\" selected=true>" + location.title + "</option>";
          } else {
            options += "<option value=\"" + location.key + "\">" + location.title + "</option>";
          }
        }
      }
    }
  }
  response = "<div id=\"question_" + question.id + "\" class=\"form-group\">\n    <label id=\"label" + question.id + "\">" + label + "</label>\n    <select id=\"" + question.id + "_" + id + "\" class=\"form-control\" name=\"" + question.id + "\" onchange=\"locationChanged('" + question.id + "', '" + user_level + "', '" + id + "')\" >\n        <option value=\"NULL\" >\n            Select One\n        </option>\n        " + options + "\n    </select>\n</div>";
  return response;
};

activateVector = function(key, id) {
  var control, keys, results;
  results = [];
  for (keys in drawControls) {
    control = drawControls[keys];
    if (key === keys) {
      if (key === "point") {
        $("a.addmap").tab("show");
      }
      results.push(control.activate());
    } else {
      results.push(control.deactivate());
    }
  }
  return results;
};

Date.prototype.getMonthName = function() {
  var monthNames;
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return monthNames[this.getMonth()];
};

validateData = function() {
  var i, instance, j, page, question;
  instance = POI[window.current_id].instance;
  i = 0;
  while (i < instance.pages.length) {
    page = instance.pages[i];
    j = 0;
    while (j < page.questions.length) {
      question = page.questions[j];
      if ((question.value === "" || question.value === undefined) && question.optional === false) {
        alert("Provide an answer for " + question.text);
        return false;
      }
      j++;
    }
    i++;
  }
  return true;
};

checkKey = function(evt) {
  var key;
  return key = (window.event ? evt.which : evt.keyCode);
};

changeDatabase = function() {
  var db;
  db = document.getElementById("databaseName").value;
  if (db.length === 0) {
    bootbox.alert("Fill in your Account name");
    return;
  }
  return window.location = "/" + db;
};

toggleDatabase = function() {
  if ($("#login input[name='databaseName']").closest('div').hasClass('hide')) {
    $("#login input[name='databaseName']").closest('div').removeClass('hide');
    if (typeof instance !== "undefined" && instance !== null) {
      return $("#login input[name='databaseName']").val(instance);
    }
  } else {
    return changeDatabase();
  }
};

$("#login button[name='change']").on("click", toggleDatabase);

$("form[name='database-form']").on("submit", function(evt) {
  changeDatabase();
  return evt.preventDefault();
});

showActivateLicense = function() {
  return $("#modal-license").modal("show");
};

$(".dropdown.settings .activate-license").on("click", showActivateLicense);

$('#btnactivatelicense').click(function() {
  return activateLicensekey().done(function(activation) {});
});

$(document).ready(function() {});

openAinsDialog = function() {
  var i, projects;
  projects = document.getElementById("projects");
  i = projects.length;
  while (i >= 1) {
    projects.remove(i);
    i--;
  }
  $.ajax({
    type: "GET",
    url: baseUrl + "app/projects/" + userID,
    headers: {
      "Content-Type": "application/json",
      userid: userName,
      key: pwrd
    },
    success: function(result) {
      var results, x;
      x = 0;
      results = [];
      while (x < result.length) {
        projects.add(new Option(result[x].project_name, result[x].project_number), null);
        results.push(x++);
      }
      return results;
    }
  });
  return $("#ains-modal").modal("show");
};

$("#ainsButton").on("click", openAinsDialog);

showQuickGuideSlide = function() {
  return $("#quick-guide-modal").modal("show");
};

$("#guide-button").on("click", function() {
  return $("#quick-guide-modal").modal("show");
});

cancelAddPOI = function() {
  if (confirm("Are you sure you want to cancel adding a new POI?")) {
    return $("#addpoi-modal").modal("hide");
  }
};


/*
Creates a node Object representing the Question.
 */

limitrange = function(rangearray, elem) {
  var isrange, myval;
  myval = document.getElementById(elem).value;
  myval = myval.replace("\"", "");
  isrange = false;
  if (rangearray.indexOf(myval) !== -1) {
    isrange = true;
  }
  if (!isrange) {
    return document.getElementById(elem).value = "";
  }
};


/*
This function opens up the add poi form
the argument taken is the id of the form
 */

addPOI = function(id, answerModel, defaultPOI) {
  return root.showAnswer(answerModel, null, true);

  /*
  tabView = $("#tabView")
  $("#map").hide()
  $("#mediaGalleryContainer").hide()
  $("#map-table-container .tableview").hide()
  
  $("#map-table-container").toggleClass("col-md-9 col-md-12")
  $("#leftPanel").toggleClass("hide")
  if tabView.length is 0
    $("#map-table-container").append """
      <div id="tabView"></div>
    """
  
  adv = new poimapper.views.AddDataPointView({ id : id, answerModel : answerModel, defaultPOI : defaultPOI, formCollection : formCollection })
  adv.render()
   */

  /*
    formModel = formCollection.get(id)
     * get the locations to be shown in location hierarchy questions
    userLocations = []
  
     * check the user level that is the highest
    userLevel = _.min window.level
     * make it a number as it is passed as a string
    userLevel = Number userLevel
  
     * the server provided user level might be null or a number (TODO: this is a bug for data validity) this turns out to be Infinity
    if userLevel is Infinity
        userLevel = 0
  
    if !window.postal_code_enabled
      for locid in location_id
        userLocations = userLocations.concat locationHierarchyView.getLocationsIn locid
  
    if userLocations.length is 0
        userLocations = locationHierarchyView.getAllLocations()
  
    if answerModel?
      fv = new poimapper.FormView({
        answerModel: answerModel,
        model: formModel,
        locations: userLocations,
        locationLabels: window.locationLabels,
        userLevel: userLevel,
        id: "formInputContent"})
  
    else
      fv = new poimapper.FormView({
        model: formModel,
        locations: userLocations,
        locationLabels: window.locationLabels,
        userLevel: userLevel,
        id: "formInputContent"})
  
    #$("#addpoi-modal").modal({backdrop: 'static'})
    $("#addpoi-modal .modal-body").html ""
    $("#addpoi-modal .modal-body").append fv.render(true).$el
    #if defaultPOI then $("#addpoi-modal .btn.default").addClass "hide" else $("#addpoi-modal .btn.default").removeClass "hide"
  
    #if answerModel?
      #fv.resetAddressFields()
      #fv.reverseGeoCode()
    $("#addpoi-modal").one "shown.bs.modal", ->
        fv.createWidgets(true)
        if answerModel?
          fv.reverseGeoCode()
         * if bowser does not support the form attr add event listener to all elements that require this
        doSubmit = (evt) ->
             * submit the formInputContent form
            $("#formInputContent").submit()
  
        $('.btn.default').on "click", ->
          fv.default_poi = true
          doSubmit()
  
        $('.btn.save-poi').on "click", ->
          fv.answerModel.set({ id : null }, { silent : true })
          doSubmit()
  
        unless Modernizr.formattr # check if formattr is supported if not then do manual submit
            $('[form="formInputContent"]').on "click", doSubmit
  
        $("body").addClass("modal-open") # Add modal open class to body to fix the scrolling issue.
        fv.on "submit", (view) ->
             * close the add poi modal
            $("#addpoi-modal").modal "hide"
            view.remove() # remove the view and remove all event listeners
  
            unless Modernizr.formattr
                $('[form="formInputContent"]').off "click", doSubmit
  
            $('.btn.default').off()
             * here also make sure the single instance is shown after adding a POI
             * window.FormView view.answerModel.id, view.model.id, false
            #window.showAnswer view.answerModel # BG 2096 Return to table or map view
  
    $("#addpoi-modal .modal-body").on "keydown", (evt) ->
      if(evt.keyCode == 13 and evt.target.type isnt "textarea" and $(evt.target).parent("form.leaflet-control-geocoder-form").length isnt 1)
        evt.preventDefault()
  
    $("#addpoi-modal").modal "show"
   */
};

createTableQuestion = function(id) {
  var html, i, j, k, l, len, len1, objPOI, qn, ref, ref1, tableRows;
  tableRows = window.tableRows;
  objPOI = getPOIByID(id);
  html = "";
  html += "<div class=\"form-group\">\n    <div id=\"" + id + "_toparea\"><b>" + objPOI.name + "</b>";
  if (tableRows[objPOI.identifier] === undefined || tableRows[objPOI.identifier].length === 0) {
    html += "<a class='btn btn-default btn-sm' id='editButton" + objPOI.id + "' onclick='addRow(" + id + ")'>Add row</a>";
  }
  html += "</div><table id='tab" + id + "' class='tblout' border='0' cellspacing='0' cellpadding='0'>";
  html += "<tr class=alt3><td></td>";
  ref = objPOI.instance.questions;
  for (k = 0, len = ref.length; k < len; k++) {
    qn = ref[k];
    if (!(qn.inVisible || !checkQTypeDisplay(qn.type))) {
      html += "<td style=cursor:pointer; ><b><u>" + qn.text + "</u></b></td>";
    }
  }
  if (tableRows[objPOI.identifier] === undefined || tableRows[objPOI.identifier].length === 0) {
    html += "<td></td>";
  }
  html += "</tr>";
  if (tableRows[objPOI.identifier] === undefined || tableRows[objPOI.identifier].length === 0) {
    html += "<tr id=" + id + "pr0 class=alt4>";
    html += "<td class=lft><b>1</b></td></td>";
    i = 0;
    ref1 = objPOI.instance.questions;
    for (l = 0, len1 = ref1.length; l < len1; l++) {
      qn = ref1[l];
      if (qn.id === "ID") {
        html += "<input type='hidden' id='data" + id + qn.id + "0' value=''/>";
      } else if (!(qn.inVisible || !checkQTypeDisplay(qn.type))) {
        html += "<td><input type='text' name='" + qn.id + "' id='" + id + qn.id + "0' /></td>";
      }
    }
    html += "<td><input type='button' value='remove' name='1' onclick='deleteRow(1, " + id + ")'/></td>";
    html += "</tr>";
  } else {
    j = 0;
    while (j < tableRows[objPOI.identifier].length) {
      html += "<tr id=" + id + "p" + "r" + j + " class=alt4>";
      html += "<td class=lft><b>" + tableRows[objPOI.identifier][j] + "</td></td>";
      i = 0;
      while (i < objPOI.instance.questions.length) {
        qn = objPOI.instance.questions[i];
        if (qn.id === "ID") {
          html += "<input type='hidden' id='data" + id + qn.id + j + "' value=''/>";
        }
        if (!(qn.inVisible || !checkQTypeDisplay(qn.type))) {
          html += "<td><input type='text' name='" + qn.id + "' id='" + id + qn.id + "" + (j + 1) + "' value='' /></td>";
        }
        i++;
      }
      html += "</tr>";
      j++;
    }
  }
  return html += "</table></div>";
};


/*
Creates a node Object representing the Question.
 */

createQuestionDisplay = function(question, formNo, firstPage, id) {

  /*
  Creates a Multiple Select Field
   */
  var checkboxes, evalArray, html, i, imageAttach, imageNo, j, k, key, len, mandatory, myopt, opt, qn, ref, response, subQ, totrim, val_, values, y, z;
  response = "";
  if (POI[id].instance.imageNo[formNo] !== undefined) {
    imageNo = POI[id].instance.imageNo[formNo];
  }
  if (question.inVisible && !(question.id === "Location1" || question.id === "Location2" || question.id === "Location3" || question.id === "Location4")) {
    return "";
  }
  if (question.type === "SelectMultipleQuestion") {
    values = [];
    if (question.ans[formNo] !== undefined) {
      values = question.ans[formNo].split(",");
    }
    i = 0;
    checkboxes = "";
    while (i < question.options.length) {
      opt = question.options[i];
      checkboxes += "<div class='checkbox'>";
      if (question.action[opt] !== undefined) {
        myopt = opt.replace(/ /g, "");
        myopt = (removeSpace(trim1(myopt.replace(".", "_")))).replace("", "_");
        checkboxes += "    <div style=\"padding-left:40px;\"\n    id=\"sq_" + question.id + myopt + "\"\n    class=\"subqDivCollapsed\"\n    onclick=\"hideSqNew('" + question.id + myopt + "', 'sq_" + question.id + myopt + "')\">\n</div>";
      }
      checkboxes += "<label><input name='" + question.id + "' ";
      if (firstPage) {
        checkboxes += "id=\"" + question.id + "\" ";
      } else {
        checkboxes += "id=\"_" + question.id + "\" ";
      }
      checkboxes += "type='checkbox' value='" + opt + "' disabled ";
      if (question.action[opt] !== undefined) {
        checkboxes += " onchange=\"showSubQuestion('" + question.id + "_" + removeSpace(trim1(opt)) + "', '" + removeSpace(trim1(opt)) + "', '" + question.id + "')\"";
      } else {
        checkboxes += " onchange=\"hideSubQuestion('" + opt + "', '" + question.id + "')\" ";
      }
      if (existsInArray(values, opt)) {
        checkboxes += " checked ";
      }
      checkboxes += "/>" + opt + "</label></div>";
      if (question.action[opt] !== undefined) {
        myopt = opt.replace(/ /g, "");
        myopt = (removeSpace(trim1(myopt.replace(".", "_")))).replace("", "_");
        subQ = question.action[opt];
        checkboxes += "<div class=\"" + question.id + myopt + "\" style=\"margin-left : 20px; display : none\">";
        j = 0;
        while (j < subQ.length) {
          checkboxes += createQuestionDisplay(subQ[j], formNo, firstPage, id);
          j++;
        }
        checkboxes += "</div>";
      }
      i++;
    }
    mandatory = "";
    if (question.optional === false) {
      mandatory = "<span class='text-danger'>*</span>";
    }
    imageAttach = "";
    if (question.attachImage === true) {
      imageAttach = "<img onclick=hideAttachedImage('" + question.id + "_image') src='" + image_res + "has_image.png' />";
    }
    response += "<div id=\"" + question.id + "\" class=\"form-group\">\n    <label id=\"label" + question.id + "\">" + question.text + "\n        " + mandatory + "\n        " + imageAttach + "\n    </label>\n    " + checkboxes + "\n</div>";
  } else if (question.type === "BooleanQuestion") {
    response += "<div id=\"" + question.id + "\" class=\"form-group\">";
    response += ("<label id=\"label" + question.id + "\">") + question.text;
    if (question.optional === false) {
      response += " <span style=\"color:red\">*</span>";
    }
    if (question.attachImage === true) {
      response += "<img onclick=\"hideAttachedImage('" + question.id + "_image')\" src='" + image_res + "has_image.png' style='float : right; cursor : pointer;' />";
    }
    response += "</label><br/>";
    opt = "Yes";
    response += "<div class=\"option\">";
    if (question.action[opt] !== undefined) {
      response += "<div style='padding-left:40px;' id=\"sq_" + question.id + "_" + removeSpace(trim1(opt)) + "\" class=\"subqDivCollapsed\" onclick=\"hideSqNew('" + question.id + "_" + removeSpace(trim1(opt)) + "', '" + "sq_" + question.id + "_" + removeSpace(trim1(opt)) + "' )\"></div>";
    } else {
      response += "<div class=\"nosubdDiv\"></div>";
    }
    response += "<input type=\"radio\" value=\"Yes\" disabled ";
    if (firstPage) {
      response += "name=\"" + question.id + "\" ";
    } else {
      response += "name=\"_" + question.id + "\" ";
    }
    if (question.ans[formNo] === opt) {
      response += " checked ";
    }
    if (question.action["Yes"] !== undefined) {
      response += " onchange=\"showSubQuestion('" + question.id + "_" + opt + "', 'Yes', '" + question.id + "')\"";
    } else {
      response += " onchange=\"hideSubQuestion('Yes', '" + question.id + "')\" ";
    }
    response += "> Yes</input></div>";
    if (question.action[opt] !== undefined) {
      subQ = question.action[opt];
      response += "<div class=\"" + question.id + "_" + opt + "\" style=\"margin-left : 20px; display : none\">";
      j = 0;
      while (j < subQ.length) {
        response += createQuestionDisplay(subQ[j], formNo, firstPage, id);
        j++;
      }
      response += "</div>";
    }
    opt = "No";
    response += "<div class=\"option\">";
    if (question.action[opt] !== undefined) {
      response += "<div style='padding-left:40px;' id=\"sq_" + question.id + "_" + removeSpace(trim1(opt)) + "\" class=\"subqDivCollapsed\" onclick=\"hideSqNew('" + question.id + "_" + removeSpace(trim1(opt)) + "', '" + "sq_" + question.id + "_" + removeSpace(trim1(opt)) + "' )\"></div>";
    } else {
      response += "<div class=\"nosubdDiv\"></div>";
    }
    response += "<input type=\"radio\" value=\"No\" disabled ";
    if (firstPage) {
      response += "name=\"" + question.id + "\" ";
    } else {
      response += "name=\"_" + question.id + "\" ";
    }
    if (question.ans[formNo] === opt) {
      response += " checked ";
    }
    if (question.action["No"] !== undefined) {
      response += " onchange=\"showSubQuestion('" + question.id + "_" + opt + "', 'No', '" + question.id + "')\"";
    } else {
      response += " onchange=\"hideSubQuestion('No', '" + question.id + "')\" ";
    }
    response += "> No</input></div>";
    if (question.action[opt] !== undefined) {
      subQ = question.action[opt];
      response += "<div class=\"" + question.id + "_" + opt + "\" style=\"margin-left : 20px; display : none\">";
      j = 0;
      while (j < subQ.length) {
        response += createQuestionDisplay(subQ[j], formNo, firstPage, id);
        j++;
      }
      response += "</div>";
    }
    response += "</div>";
  } else if (question.type === "HeaderQuestion" || question.type === "Label") {
    response += "<div id=\"" + question.id + "\" class=\"form-group\"><label id=\"label" + question.id + "\" style=\"\">" + question.text + "";
    response += "</label></div>";
    if (question.attachImage === true) {
      if (imageNo !== undefined) {
        z = 0;
        while (z < imageNo.length) {
          if (imageNo[z][3].toLowerCase() !== "pictures") {
            totrim = imageNo[z][3].toLowerCase().replace("questionimages", "");
            if (totrim === question.id.toLowerCase()) {
              response += "<div class=\"thumb\"><img src=\"" + imageNo[z][1] + "\" alt=\"image" + question.id + z + "\" id=\"thumbnail_image" + question.id + z + "\" title=\"\" name=\"" + imageNo[z][0] + "\" class=\"pointer\" onmouseover=\"Large(this)\" width=\"80\" height=\"60\"/></div>";
            }
          }
          z++;
        }
      }
      response += ("<br><div id='questionimages" + question.id + "' style='display:none'><input type='button' onClick=\"addImageQuestionRow('imagesTable_") + question.id + "' ,'" + question.id + "')\" value='Add New Image'/></p>" + "<table id='imagesTable_" + question.id + "'><tr><td><input type='file' name='image" + question.id + "0' id='add_image" + question.id + "0' onchange=\"imageSelected(0)\"/></td><td><label name='label_image" + question.id + "0' id='label_image" + question.id + "0'></label></td></tr></table></div></br>";
      response += "</br></br>";
    }
  } else if (question.type === "PicturesQuestion") {
    response += "<p><label>Images</label></p>" + "<p ><input type='button' onClick=\"addImageRow('imagesTable')\" value='Add New Image'/></p>" + "<table id='imagesTable'><tr><td><input type='file' name='image0' id='add_image0' onchange=\"imageSelected(0)\"/></td><td><label name='label_image0' id='label_image0'></label></td></tr></table>";
    return response;
  } else if (question.type === "DateQuestion") {
    response += "<div id=\"" + question.id + "\" class=\"form-group\"><label id=\"label" + question.id + "\" style=\"\">" + question.text;
    if (question.optional === false) {
      response += " <span style=\"color:red\">*</span>";
    }
    if (question.attachImage === true) {
      response += "<img onclick=\"hideAttachedImage('" + question.id + "_image')\" src='" + image_res + "has_image.png' style='float : right; cursor : pointer;' />";
    }
    response += "</label><br/>";
    response += "<input class=\"inputField\" id=\"" + question.id + "_" + id + "\" name=\"" + question.id + "\" type=\"date\" readonly value=\"" + question.ans[formNo] + "\"/>";
    response += "</div>";
  } else if (question.type === "TimeOfDayQuestion") {
    response += "<div id=\"" + question.id + "\" class=\"form-group\"><label id=\"label" + question.id + "\" style=\"\">" + question.text;
    if (question.optional === false) {
      response += " <span style=\"color:red\">*</span>";
    }
    if (question.attachImage === true) {
      response += "<img onclick=\"hideAttachedImage('" + question.id + "_image')\" src='" + image_res + "has_image.png' style='float : right; cursor : pointer;' />";
    }
    response += "</label><br/>";
    response += "<input class=\"inputField\" id=\"" + question.id + "_" + id + "\" name=\"" + question.id + "\" type=\"time\" readonly value=\"" + question.ans[formNo] + "\"/>";
    response += "</div>";
  } else if (question.type === "Part_of_Question" || question.type === "SubForm" || question.type === "TableQuestion" || question.type === "IdQuestion") {
    if (question.type === "Part_of_Question" || question.type === "TableQuestion") {
      if (question.type === "Part_of_Question" || question.type === "SubForm") {
        if (question.relations[0] !== undefined) {
          response += "<div id='view" + question.id + "' class='form-group'>" + question.text + " <a class='pofData btn btn-default btn-sm' id='" + formNo + "' name='" + getPOIId(question.relations[0].ref) + "' back='1'>Click to view part-of data</a></div>";
          window.current_partOf = question.id;
          response += "<div id='edit" + question.id + "' class='form-group'>" + question.text + " <a class='btn btn-default btn-sm' onclick='addPartOf(" + getPOIId(question.relations[0].ref) + ")'> Click to edit part-of data</a> </div>";
        }
      } else if (question.type === "TableQuestion") {
        html = getDisplayTableContent(getPOIId(question.table.columns.ref), formNo, firstPage);
        response += html;
      }
    }
    return response;
  } else if (question.type === "GPSQuestion") {
    response += "<div id=\"gps_" + question.id + "\" class=\"form-group\">\n    <label id=\"label" + question.id + "\">\n        " + question.text;
    if (question.optional === false) {
      response += "<span class='text-danger'>*</span>";
    }
    if (question.attachImage === true) {
      response += "<img onclick=\"hideAttachedImage('" + question.id + "_image')\" src='" + image_res + "has_image.png' />";
    }
    response += "        <input name=\"" + question.id + "\" id=\"" + question.id + "_" + id + "\" type=\"text\" readonly value=\"" + question.ans[formNo] + "\" />\n    </label>\n    <button class=\"btn btn-default btn-sm\" id=\"coordinateButton\" onclick=\"showInstanceMap()\" >\n        Show on map\n    </button>\n</div>";
  } else if (question.type === "SelectOneQuestion") {
    response += "<div id='question_" + question.id + "'' class='form-group'>";
    response += "<label id='label" + question.id + "'>" + question.text;
    if (question.optional === false) {
      response += "<span class='text-danger'>*</span>";
    }
    if (question.attachImage === true) {
      response += "<img onclick=hideAttachedImage('" + question.id + "_image') src='" + image_res + "has_image.png' />";
    }
    response += "</label>";
    i = 0;
    while (i < question.options.length) {
      opt = question.options[i];
      response += "<div class='radio'>";
      if (question.action[opt] !== undefined) {
        myopt = opt.replace(/ /g, "");
        myopt = (removeSpace(trim1(myopt.replace(".", "_")))).replace("", "_");
        response += "<div style='padding-left:40px;' id=\"sq_" + question.id + "_" + (removeSpace(trim1(opt)).replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")) + "\" class=\"subqDivCollapsed\" onclick=\"hideSqNew('" + question.id + "_" + (removeSpace(trim1(opt)).replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")) + "', 'sq_" + question.id + "_" + (removeSpace(trim1(opt)).replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")) + "' )\"></div>";
      }
      response += "<input   ";
      if (firstPage) {
        response += " class=\"" + question.id + "\" name=\"" + question.id + "\"  id=\"" + question.id + '_' + id + "\" ";
      } else {
        response += " name=\"_" + question.id + "\" id=\"" + question.id + '_' + id + "\" ";
      }
      response += " type=\"radio\"  ";
      if (question.action[opt] !== undefined) {
        response += " onchange=\"showSubQuestion('" + question.id + "_" + removeSpace(trim1(opt)) + "', '" + removeSpace(trim1(opt)) + "', '" + question.id + "')\"";
      } else {
        response += " onchange=\"hideSubQuestion('" + opt + "', '" + question.id + "')\" ";
      }
      response += "disabled value=\"" + opt + "\"";
      if (trim1(question.ans[formNo]) === trim1(opt)) {
        response += " checked ";
      }
      response += ">" + opt + "</input></div>";
      if (question.action[opt] !== undefined) {
        subQ = question.action[opt];
        response += "<div class=\"" + question.id + "_" + removeSpace(trim1(opt)).replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "") + "\" style=\"margin-left : 20px; display : none\">";
        j = 0;
        while (j < subQ.length) {
          response += createQuestionDisplay(subQ[j], formNo, firstPage, id);
          j++;
        }
        response += "</div>";
      } else {

      }
      i++;
    }
    response += "</div>";
  } else if (question.id === "Location1" || question.id === "Location2" || question.id === "Location3" || question.id === "Location4") {
    return addLocationQuestionDisplay(question, formNo, id);
  } else if (question.id === "user_id") {
    response += "<div id=\"" + question.id + "\" class=\"form-group\"><label id=\"label" + question.id + "\" style=\"\">" + question.text + "</label><br/>";
    response += question.ans[formNo];
    response += "</div>";
  } else if (question.id === "Name") {
    response += "<div id=\"question_" + question.id + "\" class=\"form-group\">";
    response += "<label style=\"\" id=\"label" + question.id + "\"";
    response += ">" + question.text;
    if (question.optional === false) {
      response += " <span style=\"color:red\">*</span>";
    }
    if (question.attachImage === true) {
      response += "<img onclick=\"hideAttachedImage('" + question.id + "_image')\" src='" + image_res + "has_image.png' style='float : right; cursor : pointer;' />";
    }
    response += "</label><br/>";
    if (question.type !== "IntQuestion") {
      response += "<input class=\"inputField inputText\" name=\"" + question.id + "\" id=\"" + question.id + "_" + id + "\" type=\"text\" value=\"" + question.ans[formNo] + "\" readonly ";
    } else {
      response += "<input type=\"number\" onkeypress=\"return isNumberKey(event)\" name=\"" + question.id + "\" id=\"" + question.id + "_" + id + "\" type=\"text\" value=\"" + question.ans[formNo] + "\" readonly ";
    }
    response += "</div>";
  } else {
    if (question.type !== "SkipQuestion") {
      response += "<div id=\"question_" + question.id + "\" class=\"form-group\">";
      response += "<label style=\"\" id=\"label" + question.id + "\"";
      response += ">" + question.text;
      if (question.optional === false) {
        response += " <span style=\"color:red\">*</span>";
      }
      response += "</label><br/>";
      if (question.attachImage === true) {
        if (imageNo !== undefined) {
          z = 0;
          while (z < imageNo.length) {
            if (imageNo[z][3].toLowerCase() !== "pictures") {
              totrim = imageNo[z][3].toLowerCase().replace("questionimages", "");
              if (totrim === question.id.toLowerCase()) {
                response += "<div class=\"thumb\"><img src=\"" + imageNo[z][1] + "\" alt=\"image" + question.id + z + "\" id=\"thumbnail_image" + question.id + z + "\" title=\"\" name=\"" + imageNo[z][0] + "\" class=\"pointer\" onmouseover=\"Large(this)\" width=\"80\" height=\"60\"/></div>";
              }
            }
            z++;
          }
        }
        response += ("<br><div id='questionimages" + question.id + "' style='display:none'><input type='button' onClick=\"addImageQuestionRow('imagesTable_") + question.id + "' ,'" + question.id + "')\" value='Add New Image'/></p>" + "<table id='imagesTable_" + question.id + "'><tr><td><input type='file' name='image" + question.id + "0' id='add_image" + question.id + "0' onchange=\"imageSelected(0)\"/></td><td><label name='label_image" + question.id + "0' id='label_image" + question.id + "0'></label></td></tr></table></div></br>";
        response += "</br></br>";
      }
      if (question.type !== "IntQuestion") {
        response += "<textarea class=\"inputField inputText\" cols=\"70\" rows=\"3\" name=\"" + question.id + "\" id=\"" + question.id + "_" + id + "\" type=\"text\" readonly ";
        val_ = (question.ans[formNo] === undefined ? "" : question.ans[formNo]);
        response += ">" + val_ + "</textarea>";
      } else {
        val_ = (question.ans[formNo] === undefined ? "" : question.ans[formNo]);
        response += "<input  type=\"number\" onkeypress=\"return isNumberKey(event)\" value=\"" + val_ + "\" name=\"" + question.id + "\" id=\"" + question.id + "_" + id + "\" type=\"text\" value=\"" + question.ans[formNo] + "\" readonly />";
      }
      response += "</div>";
    }
  }
  if (question.evaluate !== "" && question.evaluate !== undefined) {
    evalArray = question.evaluate.split(",");
    z = 0;
    while (z < evalArray.length) {
      y = 0;
      while (y < POI[id].instance.pages.length) {
        ref = POI[id].instance.pages[y].questions;
        for (k = 0, len = ref.length; k < len; k++) {
          qn = ref[k];
          if (qn.id === evalArray[z]) {
            subQ = qn.action["No"];
            if (subQ != null) {
              j = 0;
              while (j < subQ.length) {
                if (subQ[j].hasSubquestions) {
                  for (key in subQ[j].action) {
                    response += "<div class=\"" + subQ[j].action[key][0].id + "\" id=\"" + subQ[j].action[key][0] + "\" >";
                    response += createQuestionDisplay(subQ[j].action[key][0], formNo, firstPage, id);
                    response += "</div>";
                  }
                } else {
                  response += "<div class=\"" + subQ[0].id + "\" id=\"" + subQ[0].id + "\" >";
                  response += createQuestionDisplay(subQ[j], formNo, firstPage, id);
                  response += "</div>";
                }
                j++;
              }
            }
            subQ = qn.action["Yes"];
            if (subQ != null) {
              j = 0;
              while (j < subQ.length) {
                if (subQ[j].hasSubquestions) {
                  for (key in subQ[j].action) {
                    response += "<div class=\"" + subQ[j].action[key][0].id + "\" id=\"" + subQ[j].action[key][0].id + "\" >";
                    response += createQuestionDisplay(subQ[j].action[key][0], formNo, firstPage, id);
                    response += "</div>";
                  }
                } else {
                  response += "<div class=\"" + subQ[0].id + "\" id=\"" + subQ[0].id + "\" >";
                  response += createQuestionDisplay(subQ[j], formNo, firstPage, id);
                  response += "</div>";
                }
                j++;
              }
            }
          }
        }
        y++;
      }
      z++;
    }
  }
  if (question.attachImage === true) {
    response += addAttachImage(question, formNo);
  }
  return response;
};


/*
Create dialog for a new Part of form for filling in data.
 */

addPartOf = function(id) {
  if (POI[id] === undefined) {
    alert("POI not yet loaded");
    return;
  }
  return addPartOfPage(0, id, -1);
};

reportTableQuestions = function(question, therealname) {
  var k, l, len, len1, ref, ref1, squestion, tm, triggerValue;
  if (question.triggerValues != null) {
    ref = question.triggerValues.triggerValue;
    for (k = 0, len = ref.length; k < len; k++) {
      triggerValue = ref[k];
      if (triggerValue.action.subQuestions != null) {
        ref1 = triggerValue.action.subQuestions.question;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          squestion = ref1[l];
          if (squestion.type === "TableQuestion" && squestion.inVisible === false) {
            tm = window.formCollection.findWhere({
              "ref": squestion.table.columns.relation[0].ref
            });
            therealname[tm.id] = squestion.text;
          }
          therealname = reportTableQuestions(squestion, therealname);
        }
      }
    }
  }
  return therealname;
};

downloadReport = function() {
  var destSelect, i, levels, nodes, rootNode, select, srcSelect, therealname;
  select = document.getElementById("poiTypeReport");
  i = select.length;
  while (i >= 1) {
    select.remove(i);
    i--;
  }
  srcSelect = document.getElementById("questionName");
  i = srcSelect.length;
  while (i >= 0) {
    srcSelect.remove(i);
    i--;
  }
  destSelect = document.getElementById("questionNameSelected");
  i = destSelect.length;
  while (i >= 0) {
    destSelect.remove(i);
    i--;
  }
  changeReportUI();
  document.getElementById("includelocation").checked = false;
  $("#report_id").val("");
  $("#report_name").val("");
  therealname = {};
  formCollection.each(function(model) {
    if (model.get("type") !== "TABLE") {
      return _.each(model.get("questionPage"), function(page) {
        return _.each(page.question, function(question) {
          var tm;
          if (question.type === "TableQuestion" && question.inVisible === false) {
            tm = window.formCollection.findWhere({
              "ref": question.table.columns.relation[0].ref
            });
            therealname[tm.id] = question.text;
          }
          return therealname = reportTableQuestions(question, therealname);
        });
      });
    }
  });
  formCollection.each(function(model) {
    if (!model.get("isChild") && model.get("type") === "POI") {
      return select.add(new Option(model.get("name"), model.get("ref")), null);
    } else if (model.get("isChild") && model.get("type") === "POI") {
      return select.add(new Option("Subform: " + (model.get("name")), model.get("ref")), null);
    } else if (model.get("isChild") && model.get("type") === "TASKFORM") {
      return select.add(new Option("Task Form: " + (model.get("name")), model.get("ref")), null);
    } else if (model.get("isChild") && model.get("type") === "TABLE") {
      if (therealname[model.id] !== undefined) {
        return select.add(new Option("Table: " + therealname[model.id], model.get("ref")), null);
      }
    }
  });
  levels = document.getElementById("locationLevel");
  i = levels.length;
  while (i >= 0) {
    levels.remove(i);
    i--;
  }
  i = 0;
  while (i < window.locationLabels.length) {
    if (window.locationLabels[i] !== null && window.locationLabels[i] !== "Location 1" && window.locationLabels[i] !== "Location 2" && window.locationLabels[i] !== "Location 3" && window.locationLabels[i] !== "Location 4" && window.locationLabels[i] !== "null") {
      levels.add(new Option(window.locationLabels[i], i + 1), null);
    } else {

    }
    i++;
  }
  document.getElementById("locationLevel").value = 1;
  levels = document.getElementById("locationLevelDataFilter");
  i = levels.length;
  while (i >= 0) {
    levels.remove(i);
    i--;
  }
  levels.add(new Option("All", -1), null);
  rootNode = $("#tree").dynatree("getRoot");
  nodes = rootNode.childList;
  i = 0;
  while (i < nodes.length) {
    levels.add(new Option(nodes[i].data.title, nodes[i].data.key), null);
    i++;
  }
  $("#locationLevelDiv").hide();
  $("#orientationrow").hide();
  document.getElementById("chart").value = -1;
  document.getElementById("type").value = -1;
  document.getElementById("excludenull").checked = false;
  $("#reports-modal").modal("show");
  $("#chartingTable").hide();
  $("#numericfieldsrow").hide();
  $("#subgrouprow").hide();
  $("#criteriarow").hide();
  toggleLegendTable(0);
  return changedColumnQuestion();
};

changeReportUI = function() {
  $("#reportFormDiv").show();
  $("#locationLevelDiv").hide();
  $("#chartDiv").show();
  $("#orientationrow").hide();
  $("#includelocationnewdatarow").show();
  $("#legendrow").show();
  $("#rowgroup").show();
  $("#numericfieldsrow").hide();
  $("#chartingTable").hide();
  $("#questionPanel").show();
  $("#save-report").show();
  $("#formatDiv").show();
  $("#excludenonresponse").show();
  $("#orientationrow").show();
  $("#yaxisrow").show();
  $("#subgrouprow").show();
  return $("#criteriarow").show();
};

changedFormType = function() {
  var formId;
  formId = document.getElementById("poiTypeReport").value;
  document.getElementById("chart").value = -1;
  document.getElementById("includelocation").checked = false;
  document.getElementById("combinenumericfields").checked = false;
  document.getElementById("locationreport").checked = false;
  return changedChartType("");
};

loadSavedReports = function() {
  $('#filter_title').prevAll('li').remove();
  return $.ajax({
    type: "GET",
    url: baseUrl + "app/reports/" + userID,
    headers: {
      "Content-Type": "application/json",
      userid: userName,
      key: pwrd
    },
    success: function(result) {
      var report_html, x;
      x = 0;
      report_html = "<li id='template_title' class='dropdown-header templateheader'>" + messages.templates + "</li>";
      while (x < result.length) {
        report_html += "<li id=\"report" + result[x].report_id + "\">\n<a href=\"#\"> <div id=\"report-" + x + "\" data-reportid=\"" + result[x].report_id + "\" class=\"report-template pull-left\">" + result[x].report_name + "</div> <div><i style=\"margin-left:10px;\" data-reportid=\"" + result[x].report_id + "\" class=\"fa fa-pencil edit-report pull-left\"></i></div> <div><i style=\"margin-left:10px;\" data-reportid=\"" + result[x].report_id + "\" class=\"fa fa-trash delete-report\"></i></div></a>\n</li>";
        x++;
      }
      return $("#filter_title").before(report_html);
    }
  });
};

$("#poiTypeReport").on("change", changedFormType);

$("#legendQuestion").on("change", showSubgroupField);

showSubgroupField = function() {
  if (document.getElementById("legendQuestion").value !== "") {
    return $("#subgrouprow").show();
  } else {
    return $("#subgrouprow").hide();
  }
};

changedColumnQuestion = function() {
  var chartType, i, legendQuestionid, levels, results, results1, select1, select2, value_id;
  select1 = document.getElementById("legendQuestion");
  select2 = document.getElementById("rowquestion");
  if (select1.options.length > 1) {
    i = select2.options.length;
    while (i >= 0) {
      select2.remove(i);
      i--;
    }
    i = 0;
    select2.add(new Option("Select One", ""), null);
    select2.add(new Option("Users", "user_id"), null);
    while (i < select1.length) {
      if (select1[i].value !== select1.value && select1[i].value !== "") {
        select2.add(new Option(select1.options[i].text, select1[i].value), null);
        if (select1.options[i].disabled) {
          select2.options[i - 1].disabled = true;
        }
      }
      i++;
    }
  }
  legendQuestionid = document.getElementById("legendQuestion").value;
  chartType = document.getElementById("chart").value;
  if (legendQuestionid !== "" && chartType === "-2") {
    $("#rowgroup").show();
    document.getElementById("rowquestion").disabled = false;
  } else {
    document.getElementById("rowquestion").value = "";
    if (chartType !== "-2") {
      $("#rowgroup").hide();
    }
    document.getElementById("rowquestion").disabled = true;
  }
  if (legendQuestionid !== "" && chartType === "-1") {
    $("#subgrouprow").show();
  } else {
    $("#subgrouprow").hide();
  }
  if (legendQuestionid === "1" || legendQuestionid === "2" || legendQuestionid === "3" || legendQuestionid === "4") {
    levels = document.getElementById("locationLevel");
    i = levels.length;
    while (i >= 0) {
      levels.remove(i);
      i--;
    }
    i = 0;
    results = [];
    while (i < window.locationLabels.length) {
      value_id = i + 1;
      if (value_id < legendQuestionid) {
        if (window.locationLabels !== null && window.locationLabels[i] !== "Location 1" && window.locationLabels[i] !== "Location 2" && window.locationLabels[i] !== "Location 3" && window.locationLabels[i] !== "Location 4" && window.locationLabels[i] !== "null") {
          levels.add(new Option(window.locationLabels[i], i + 1), null);
        }
      }
      results.push(i++);
    }
    return results;
  } else {
    levels = document.getElementById("locationLevel");
    i = levels.length;
    while (i >= 0) {
      levels.remove(i);
      i--;
    }
    i = 0;
    results1 = [];
    while (i < window.locationLabels.length) {
      if (window.locationLabels !== null && window.locationLabels[i] !== "Location 1" && window.locationLabels[i] !== "Location 2" && window.locationLabels[i] !== "Location 3" && window.locationLabels[i] !== "Location 4" && window.locationLabels[i] !== "null") {
        levels.add(new Option(window.locationLabels[i], i + 1), null);
      }
      results1.push(i++);
    }
    return results1;
  }
};

$("#legendQuestion").on("change", changedColumnQuestion);

changedRowQuestion = function() {
  var chartId, destSelect, formId, formModel, i, rowQuestionid, rowquestion, srcSelect;
  chartId = document.getElementById("chart").value;
  srcSelect = document.getElementById("questionName");
  formId = document.getElementById("poiTypeReport").value;
  formModel = window.formCollection.findWhere({
    ref: formId
  });
  rowquestion = document.getElementById("rowquestion");
  rowQuestionid = document.getElementById("rowquestion").value;
  destSelect = document.getElementById("questionNameSelected");
  if (rowQuestionid !== "") {
    i = srcSelect.length;
    while (i >= 0) {
      srcSelect.remove(i);
      i--;
    }
    i = destSelect.length;
    while (i >= 0) {
      destSelect.remove(i);
      i--;
    }
    i = 0;
    if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
      formModel = window.formCollection.findWhere({
        ref: formId
      });
      return _.each(formModel.get("questionPage"), function(page) {
        return _.each(page.question, function(qn) {
          if (!qn.inVisible || (qn.text === "Count" || qn.text === "count" || qn.id === "countQuestion")) {
            if (qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) {
              return srcSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
            }
          }
        });
      });
    } else if (formModel.get("type") === 'TABLE') {
      formModel = window.formCollection.findWhere({
        ref: formId
      });
      return _.each(formModel.get("question"), function(qn) {
        if (!qn.inVisible || (qn.text === "Count" || qn.text === "count" || qn.id === "countQuestion")) {
          if (qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) {
            return srcSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
          }
        }
      });
    }
  } else {
    return changedChartType("");
  }
};

$("#rowquestion").on("change", changedRowQuestion);


/*
Invoked after a question is selected on the left selection box.
It gets the Selected part of instance and fills in the data into the form.
id - The POI id of the Part of questionnaire
 */

selectQuestion = function(id) {
  var i, results, select, selected;
  selected = document.getElementById("questionSelect").value;
  select = document.getElementById("questionSelect");
  i = 0;
  results = [];
  while (i < select.length) {
    if (select[i].value === selected) {
      document.getElementById("currentIndex").value = i;
      setPartOfFormValues(id);
    }
    results.push(i++);
  }
  return results;
};

questionSelected = function(evt) {
  var destSelect, i, opt, options, srcSelect, x;
  srcSelect = document.getElementById("questionName");
  destSelect = document.getElementById("questionNameSelected");
  options = srcSelect.options;
  x = $("#questionName option:selected").length;
  if (x > 1) {
    if (destSelect.length <= 499) {
      i = srcSelect.length - 1;
      while (i >= 0) {
        opt = options.item(i);
        if (opt.selected) {
          if (destSelect.length <= 500) {
            $("#questionNameSelected").prepend(opt);
          }
        }
        i--;
      }
    } else {
      bootbox.alert("A maximum of 500 questions is supported in one report");
    }
  } else {
    if (destSelect.length <= 499) {
      i = srcSelect.length - 1;
      while (i >= 0) {
        opt = options.item(i);
        if (opt.selected) {
          if (destSelect.length <= 500) {
            destSelect.add(opt);
          }
        }
        i--;
      }
    } else {
      bootbox.alert("A maximum of 500 questions is supported in one report");
    }
  }
  return evt.preventDefault();
};

$("#selectQuestion").on("click", questionSelected);

questionDeSelected = function(evt) {
  var destSelect, i, opt, options, srcSelect;
  srcSelect = document.getElementById("questionName");
  destSelect = document.getElementById("questionNameSelected");
  options = destSelect.options;
  i = options.length - 1;
  while (i >= 0) {
    opt = options.item(i);
    if (opt.selected) {
      srcSelect.add(opt);
    }
    i--;
  }
  return evt.preventDefault();
};

$("#deselectQuestion").on("click", questionDeSelected);

listenerAdded = false;

downloadJasperReport = function(cb) {
  var chart, combinenumericfields, criteriafield, dateFilterType, destSelect, editorFilterType, excludenull, fieldsToBeReported, format, fromdate, hasNumericFields, i, includeUsers, includelocation, includetimestamp, legendid, locFilterType, locationLevelDataFilter, locationLevels, locs, lvls, newdata, opt, options, orientation, poi, reportType, report_data, rowqs, rowquestion, selLocs, selectedUsers, subgroup, template_params, timeseriestype, todate, type, url;
  poi = document.getElementById("poiTypeReport").value;
  chart = document.getElementById("chart").value;
  destSelect = document.getElementById("questionNameSelected");
  options = destSelect.options;
  fieldsToBeReported = "";
  hasNumericFields = false;
  i = 0;
  while (i < options.length) {
    opt = options.item(i);
    if (chart === "0" || chart === "1" || chart === "2") {
      if ($(opt).attr('isnumber') === "yes") {
        hasNumericFields = true;
      }
    }
    if (fieldsToBeReported === "") {
      fieldsToBeReported += "" + opt.value;
    } else {
      fieldsToBeReported += "," + opt.value;
    }
    i++;
  }
  fieldsToBeReported += "";
  includeUsers = "0";
  includelocation = (document.getElementById("includelocation").checked ? "1" : "0");
  combinenumericfields = (document.getElementById("combinenumericfields").checked ? "1" : "0");
  editorFilterType = (document.getElementById("editorFilterType").checked ? "1" : "0");
  dateFilterType = (document.getElementById("dateFilterType").checked ? "1" : "0");
  locFilterType = (document.getElementById("locFilterType").checked ? "1" : "0");
  reportType = (document.getElementById("locationreport").checked ? "1" : "0");
  excludenull = (document.getElementById("excludenull").checked ? "1" : "0");
  locationLevelDataFilter = document.getElementById("locationLevelDataFilter").value;
  orientation = document.getElementById("orientation").value;
  format = document.getElementById("format").value;
  subgroup = document.getElementById("subgrpQuestion").value;
  criteriafield = document.getElementById("criteriaQuestion").value;
  locationLevels = document.getElementById("locationLevel").value;
  if (locationLevelDataFilter === "-1") {
    locationLevelDataFilter = "";
  }
  includetimestamp = "0";
  newdata = "1";
  type = document.getElementById("type").value;
  legendid = document.getElementById("legendQuestion").value;
  rowquestion = document.getElementById("rowquestion").value;
  timeseriestype = "";
  if (legendid === "modifiedday") {
    legendid = "modified";
    timeseriestype = "DAY";
  } else if (legendid === "modifiedweek") {
    legendid = "modified";
    timeseriestype = "WEEK";
  } else if (legendid === "modifiedmonth") {
    legendid = "modified";
    timeseriestype = "MONTH";
  } else if (legendid === "modifiedyear") {
    legendid = "modified";
    timeseriestype = "YEAR";
  } else if (legendid === "modifieddaytime") {
    legendid = "modified";
    timeseriestype = "HOUR";
  }
  if (poi === "") {
    alert("Please select a form.");
  } else if (chart === "-2" && legendid === "") {
    alert("Please select column group field.");
  } else if (chart === "-2" && rowquestion === "") {
    alert("Please select row group field.");
  } else if (options.length === 0) {
    alert("Please select the questions to be included in the report.");
  } else if (chart === "2" && legendid === "" && hasNumericFields) {
    alert("Please select the field to use as X axis");
  } else {
    selLocs = getTreeSelectedNodes();
    locs = "";
    lvls = "";
    selectedUsers = "";
    fromdate = "";
    todate = "";
    if (dateFilterType === "1") {
      fromdate = ((document.getElementById("from").value === "undefined" || document.getElementById("from").value === undefined) ? "" : document.getElementById("from").value);
      todate = ((document.getElementById("to").value === "undefined" || document.getElementById("to").value === undefined) ? "" : document.getElementById("to").value);
    }
    if (editorFilterType === "1") {
      selectedUsers = userFilterView.getAllSelectedUsersIds().join(",");
    }
    i = 0;
    locs = [];
    lvls = [];
    if (locFilterType === "1") {
      i = 0;
      lvls = "";
      while (i < selLocs.length) {
        if (i !== 0 && selLocs[i].data.key.indexOf("-") === -1) {
          locs += ",";
          lvls += ",";
        }
        if (selLocs[i].data.key.indexOf("-") === -1) {
          locs += "" + selLocs[i].data.key;
          lvls += "" + selLocs[i].getLevel();
        }
        i++;
      }
      locs = locationHierarchyView.getSelectedLocationKeys(true);
      lvls = [];
      _.each(locs, function(element, index) {
        return lvls.push(locationHierarchyView.getLevelOfNode(element));
      });
    }
    options = document.getElementById('rowquestion').selectedOptions;
    i = 0;
    while (i < options.length) {
      opt = options.item(i);
      if (i === 0) {
        rowqs = opt.value;
      } else {
        rowqs += "," + opt.value;
      }
      i++;
    }
    url = (baseUrl + "app/jasper/" + poi + "/" + includelocation + "/" + newdata + "/" + chart + "/" + type + "?key=") + pwrd + "&userid=" + userName + "&user_id=" + userID + "&questions=" + fieldsToBeReported + "&locs=" + locs + "&levels=" + lvls + "&users=" + selectedUsers + "&fromdate=" + fromdate + "&todate=" + todate + "&timeinfo=" + includetimestamp + "&userinfo=" + includeUsers + "&legendid=" + legendid + "&reportType=" + reportType + "&locationLevels=" + locationLevels + "&combinenumericfields=" + combinenumericfields + "&timeseriestype=" + timeseriestype + "&locationLevelDataFilter=" + locationLevelDataFilter + "&orientation=" + orientation + "&rowquestionid=" + rowqs + "&groupid=" + groupID + "&format=" + format + "&excludenull=" + excludenull + "&subgroup=" + subgroup + "&criteriafield=" + criteriafield;
  }
  if (format === "json") {
    report_data = {};
    report_data.url = url;
    template_params = {};
    template_params.poi = poi;
    template_params.includelocation = includelocation;
    template_params.newdata = newdata;
    template_params.chart = chart;
    template_params.type = type;
    template_params.questions = fieldsToBeReported;
    template_params.locs = locs;
    template_params.levels = lvls;
    template_params.users = selectedUsers;
    template_params.fromdate = fromdate;
    template_params.todate = todate;
    template_params.timeinfo = includetimestamp;
    template_params.userinfo = includeUsers;
    template_params.legendid = legendid;
    template_params.reportType = reportType;
    template_params.locationLevels = locationLevels;
    template_params.combinenumericfields = combinenumericfields;
    template_params.timeseriestype = timeseriestype;
    template_params.locationLevelDataFilter = locationLevelDataFilter;
    template_params.orientation = orientation;
    template_params.rowquestionid = rowqs;
    template_params.groupid = groupID;
    template_params.format = format;
    template_params.excludenull = excludenull;
    template_params.subgroup = subgroup;
    template_params.criteriafield = criteriafield;
    report_data.template_params = template_params;
    return cb(null, report_data);
  } else {
    return window.open(url, '_blank');

    /*
    					iframe = document.createElement 'iframe'
    					iframe.height = 0
    					iframe.width = 0
    					iframe.src = url
    					receiver = (evt) ->
    						if evt.origin is window.location.origin and evt.data is "no data"
        bootbox.alert "no data in report"
    
    					unless listenerAdded
      window.addEventListener 'message', receiver, false
      listenerAdded = true
    
    					$("body").append iframe
     */
  }
};

applySavedTemplate = function(reportId, row_id, Parent_form_id) {
  var dateFilterType, editorFilterType, filters, fromdate, i, locFilterType, locs, lvls, report_id, selLocs, selectedUsers, selections, singleInstance, todate, win;
  report_id = reportId;
  singleInstance = "";
  if (row_id !== void 0 && row_id !== "") {
    singleInstance = "&row_id=" + row_id + "&parent_form_id=" + Parent_form_id;
  }
  editorFilterType = (document.getElementById("filter_users").checked ? "1" : "0");
  dateFilterType = (document.getElementById("filter_dates").checked ? "1" : "0");
  locFilterType = (document.getElementById("filter_locs").checked ? "1" : "0");
  selLocs = getTreeSelectedNodes();
  locs = "";
  lvls = "";
  selectedUsers = "";
  fromdate = "";
  todate = "";
  filters = "";
  selections = "";
  i = 0;
  if (locFilterType === "1") {
    i = 0;
    lvls = "";
    while (i < selLocs.length) {
      if (i !== 0 && selLocs[i].data.key.indexOf("-") === -1) {
        locs += ",";
        lvls += ",";
      }
      if (selLocs[i].data.key.indexOf("-") === -1) {
        locs += "" + selLocs[i].data.key;
        lvls += "" + selLocs[i].getLevel();
      }
      i++;
    }
    locs = locationHierarchyView.getSelectedLocationKeys(true);
    lvls = [];
    _.each(locs, function(element, index) {
      return lvls.push(locationHierarchyView.getLevelOfNode(element));
    });
  }
  if (editorFilterType === "1") {
    selectedUsers = userFilterView.getAllSelectedUsersIds().join(",");
  }
  if (dateFilterType === "1") {
    fromdate = ((document.getElementById("from").value === "undefined" || document.getElementById("from").value === undefined) ? "" : document.getElementById("from").value);
    todate = ((document.getElementById("to").value === "undefined" || document.getElementById("to").value === undefined) ? "" : document.getElementById("to").value);
  }
  filters += "locs=" + locs + "&levels=" + lvls + "&users=" + selectedUsers + "&fromdate=" + fromdate + "&todate=" + todate;
  selections = locFilterType + "&" + editorFilterType + "&" + dateFilterType;
  win = window.open('');
  return $.ajax({
    type: "GET",
    async: false,
    url: baseUrl + "app/applytemplate/" + report_id + "/" + filters + "/" + selections,
    headers: {
      "Content-Type": "application/json",
      userid: userName,
      key: pwrd
    },
    success: function(result) {
      var url;
      url = result.message + singleInstance;
      console.log("URL", url);
      window.oldOpen = window.open;
      window.open = function(url) {
        win.location = url;
        window.open = oldOpen;
        win.focus();
      };
      return window.open(url);
    }
  });
};

deleteSavedTemplate = function(report_id) {
  var x;
  x = confirm("Are you sure you want to delete this template?");
  if (x) {
    $.ajax({
      type: "GET",
      url: baseUrl + "app/deletereport/" + report_id,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        return alert(result.message);
      }
    });
    return $("#report" + report_id).remove();
  }
};

editSavedTemplate = function(report_id) {
  if (report_id !== undefined && report_id !== "") {
    return $.ajax({
      type: "GET",
      async: false,
      url: baseUrl + "app/rawtemplatedetails/" + report_id,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        var calculation_type, combine_fields, form, format, group_by, i, levels, nodes, orientation, questions, report_name, report_type, rootNode, row_question, select, separate_location, show_locations, therealname;
        form = result[0].form;
        report_type = result[0].report_type;
        report_name = result[0].report_name;
        orientation = result[0].orientation;
        format = result[0].format;
        calculation_type = result[0].calculation_type;
        questions = result[0].question;
        group_by = result[0].column_question_group_by;
        row_question = result[0].row_question;
        combine_fields = result[0].combine_fields;
        separate_location = result[0].separate_for_location;
        show_locations = result[0].show_locations;
        select = document.getElementById("poiTypeReport");
        i = select.length;
        while (i >= 1) {
          select.remove(i);
          i--;
        }
        document.getElementById("includelocation").checked = false;
        therealname = {};
        formCollection.each(function(model) {
          if (model.get("type") !== "TABLE") {
            return _.each(model.get("questionPage"), function(page) {
              return _.each(page.question, function(question) {
                var tm;
                if (question.type === "TableQuestion" && question.inVisible === false) {
                  tm = window.formCollection.findWhere({
                    "ref": question.table.columns.relation[0].ref
                  });
                  return therealname[tm.id] = question.text;
                }
              });
            });
          }
        });
        formCollection.each(function(model) {
          if (!model.get("isChild") && model.get("type") === "POI") {
            return select.add(new Option(model.get("name"), model.get("ref")), null);
          } else if (model.get("isChild") && model.get("type") === "POI") {
            return select.add(new Option("Subform: " + (model.get("name")), model.get("ref")), null);
          } else if (model.get("isChild") && model.get("type") === "TASKFORM") {
            return select.add(new Option("Task Form: " + (model.get("name")), model.get("ref")), null);
          } else if (model.get("isChild") && model.get("type") === "TABLE") {
            if (therealname[model.id] !== undefined) {
              return select.add(new Option("Table: " + therealname[model.id], model.get("ref")), null);
            }
          }
        });
        $("#poiTypeReport").val(form);
        $("#poiTypeReport").trigger("change");
        $("#chart").val(report_type);
        changedChartType(questions);
        $("#chart").val(report_type);
        $("#orientation").val(orientation);
        if (format !== "") {
          $("#format").val(format);
        } else {
          $("#format").val('pdf');
        }
        $("#type").val(calculation_type);
        $("#legendQuestion").val(group_by);
        $("#legendQuestion").trigger("change");
        $("#rowquestion").val(row_question);
        $("#report_id").val(report_id);
        $("#report_name").val(report_name);
        if (combine_fields === "1") {
          $('#combinenumericfields').prop('checked', true);
        }
        if (separate_location === "1") {
          $('#locationreport').prop('checked', true);
        }
        if (show_locations === "1") {
          $('#includelocation').prop('checked', true);
        }
        levels = document.getElementById("locationLevel");
        i = levels.length;
        if (report_type !== "3") {
          $("#legendrow").show();
        }
        if (report_type === "0" || report_type === "1" || report_type === "2" || report_type === "3") {
          $("#excludenonresponse").show();
          $("#chartingtable").show();
        }
        if (report_type === "0" || report_type === "1" || report_type === "2") {
          $("#numericfieldsrow").show();
        }
        if (report_type === "-1" || report_type === "-2") {
          $("#yaxisrow").show();
        }
        if (report_type === "0") {
          $("#orientationrow").show();
        }
        if (report_type !== "-2") {
          $("#rowgroup").hide();
        }
        while (i >= 0) {
          levels.remove(i);
          i--;
        }
        i = 0;
        while (i < window.locationLabels.length) {
          if (window.locationLabels[i] !== null && window.locationLabels[i] !== "Location 1" && window.locationLabels[i] !== "Location 2" && window.locationLabels[i] !== "Location 3" && window.locationLabels[i] !== "Location 4" && window.locationLabels[i] !== "null") {
            levels.add(new Option(window.locationLabels[i], i + 1), null);
          } else {

          }
          i++;
        }
        document.getElementById("locationLevel").value = 1;
        levels = document.getElementById("locationLevelDataFilter");
        i = levels.length;
        while (i >= 0) {
          levels.remove(i);
          i--;
        }
        levels.add(new Option("All", -1), null);
        rootNode = $("#tree").dynatree("getRoot");
        nodes = rootNode.childList;
        i = 0;
        while (i < nodes.length) {
          levels.add(new Option(nodes[i].data.title, nodes[i].data.key), null);
          i++;
        }
        $("#reports-modal").modal("show");
        return changedColumnQuestion();
      }
    });
  }
};

editReportTemplate = function(report_id) {
  return $.ajax({
    type: "GET",
    url: baseUrl + "app/deletereport/" + report_id,
    headers: {
      "Content-Type": "application/json",
      userid: userName,
      key: pwrd
    },
    success: function(result) {
      return alert(result.message);
    }
  });
};

$("#generate-report").on("click", downloadJasperReport);

$("#save-report").on("click", function() {
  return $("#savereport-modal").modal("show");
});

$("#savereport-modal").on("hidden.bs.modal", function() {
  return $("body").addClass("modal-open");
});

$("#reports-modal").on("hidden.bs.modal", function() {
  return $("body").removeClass("modal-open");
});

saveReportTemplate = function() {
  var chart, combinenumericfields, criteriafield, dateFilterType, destSelect, editorFilterType, excludenull, fieldsToBeReported, format, fromdate, i, includeUsers, includelocation, includetimestamp, json, legendid, locFilterType, locationLevelDataFilter, locs, lvls, newdata, opt, options, orientation, params, poi, reportType, report_id, report_name, rowqs, rowquestion, selLocs, selectedUsers, subgroup, timeseriestype, todate, type, url_params;
  report_name = document.getElementById('report_name').value;
  report_id = document.getElementById('report_id').value;
  poi = document.getElementById("poiTypeReport").value;
  destSelect = document.getElementById("questionNameSelected");
  options = destSelect.options;
  fieldsToBeReported = "";
  i = 0;
  while (i < options.length) {
    opt = options.item(i);
    if (fieldsToBeReported === "") {
      fieldsToBeReported += "" + opt.value;
    } else {
      fieldsToBeReported += "," + opt.value;
    }
    i++;
  }
  fieldsToBeReported += "";
  includeUsers = "0";
  includelocation = (document.getElementById("includelocation").checked ? "1" : "0");
  combinenumericfields = (document.getElementById("combinenumericfields").checked ? "1" : "0");
  editorFilterType = (document.getElementById("editorFilterType").checked ? "1" : "0");
  dateFilterType = (document.getElementById("dateFilterType").checked ? "1" : "0");
  locFilterType = (document.getElementById("locFilterType").checked ? "1" : "0");
  reportType = (document.getElementById("locationreport").checked ? "1" : "0");
  excludenull = (document.getElementById("excludenull").checked ? "1" : "0");
  locationLevelDataFilter = document.getElementById("locationLevelDataFilter").value;
  orientation = document.getElementById("orientation").value;
  format = document.getElementById("format").value;
  subgroup = document.getElementById("subgrpQuestion").value;
  criteriafield = document.getElementById("criteriaQuestion").value;
  if (locationLevelDataFilter === "-1") {
    locationLevelDataFilter = "";
  }
  includetimestamp = "0";
  newdata = "1";
  chart = document.getElementById("chart").value;
  type = document.getElementById("type").value;
  legendid = document.getElementById("legendQuestion").value;
  rowquestion = document.getElementById("rowquestion").value;
  timeseriestype = "";
  if (legendid === "modifiedday") {
    legendid = "modified";
    timeseriestype = "DAY";
  } else if (legendid === "modifiedweek") {
    legendid = "modified";
    timeseriestype = "WEEK";
  } else if (legendid === "modifiedmonth") {
    legendid = "modified";
    timeseriestype = "MONTH";
  } else if (legendid === "modifiedyear") {
    legendid = "modified";
    timeseriestype = "YEAR";
  } else if (legendid === "modifieddaytime") {
    legendid = "modified";
    timeseriestype = "HOUR";
  }
  if (poi === "") {
    return alert("Please select a form.");
  } else if (chart === "-2" && legendid === "") {
    return alert("Please select column group field.");
  } else if (chart === "-2" && rowquestion === "") {
    return alert("Please select row group field.");
  } else if (options.length === 0) {
    return alert("Please select the questions to be included in the report.");
  } else if (report_name === "") {
    return alert("Please specify a name for the report template.");
  } else {
    selLocs = getTreeSelectedNodes();
    locs = "";
    lvls = "";
    selectedUsers = "";
    fromdate = "";
    todate = "";
    if (dateFilterType === "1") {
      fromdate = ((document.getElementById("from").value === "undefined" || document.getElementById("from").value === undefined) ? "" : document.getElementById("from").value);
      todate = ((document.getElementById("to").value === "undefined" || document.getElementById("to").value === undefined) ? "" : document.getElementById("to").value);
    }
    if (editorFilterType === "1") {
      selectedUsers = userFilterView.getAllSelectedUsersIds().join(",");
    }
    i = 0;
    if (locFilterType === "1") {
      i = 0;
      lvls = "";
      while (i < selLocs.length) {
        if (i !== 0 && selLocs[i].data.key.indexOf("-") === -1) {
          locs += ",";
          lvls += ",";
        }
        if (selLocs[i].data.key.indexOf("-") === -1) {
          locs += "" + selLocs[i].data.key;
          lvls += "" + selLocs[i].getLevel();
        }
        i++;
      }
      locs = locationHierarchyView.getSelectedLocationKeys(true);
      lvls = [];
      _.each(locs, function(element, index) {
        return lvls.push(locationHierarchyView.getLevelOfNode(element));
      });
      locs = locs.join(',');
      lvls = lvls.join(',');
    }
    options = document.getElementById('rowquestion').selectedOptions;
    i = 0;
    while (i < options.length) {
      opt = options.item(i);
      if (i === 0) {
        rowqs = opt.value;
      } else {
        rowqs += "," + opt.value;
      }
      i++;
    }
    params = $.param({
      questions: fieldsToBeReported,
      locs: locs,
      levels: lvls,
      users: selectedUsers,
      fromdate: fromdate,
      todate: todate,
      timeinfo: includetimestamp,
      userinfo: includeUsers,
      legendid: legendid,
      reportType: reportType,
      locationLevels: document.getElementById("locationLevel").value,
      combinenumericfields: combinenumericfields,
      timeseriestype: timeseriestype,
      locationLevelDataFilter: locationLevelDataFilter,
      orientation: orientation,
      rowquestionid: rowqs,
      groupid: groupID,
      format: format,
      excludenull: excludenull,
      subgroup: subgroup,
      criteriafield: criteriafield
    });
    url_params = baseUrl + "app/jasper/" + poi + "/" + includelocation + "/" + newdata + "/" + chart + "/" + type + "?XXX" + params;
    json = "{ \"report_name\" : \"" + report_name + "\" , \"parameters\" : \"" + url_params + "\", \"report_id\" : \"" + report_id + "\"}";
    return $.ajax({
      type: "POST",
      data: json,
      url: baseUrl + "app/savereport",
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        var t;
        t = result;
        if (report_id === undefined || report_id === "") {
          alert("Report template saved successfully");
        } else {
          alert("Report template changes saved successfully");
        }
        if (t.status === "OK") {
          $("#savereport-modal").modal("hide");
          if (report_id === undefined || report_id === "") {
            return $("#template_title").before("<li id=\"report" + t.message + "\"><a href=\"#\"> <div id=\"report-new\" data-reportid=\"" + t.message + "\" class=\"report-template pull-left\">" + report_name + " </div> <div><i style=\"margin-left:10px;\" data-reportid=\"" + t.message + "\" class=\"fa fa-pencil edit-report pull-left\"></i></div> <div><i style=\"margin-left:10px;\" data-reportid=\"" + t.message + "\" class=\"fa fa-trash delete-report\"></i></div></a></li>");
          }
        }
      }
    });
  }
};

changedChartType = function(questions) {
  var addSubQuestions, chartId, criteriaquestion, destSelect, formId, formModel, i, index, index2, j, k, l, legendSelect, len, len1, levels, newSq, opt, page, page_no, pages, qSelect, qn, ref, reportType, rowquestion, srcSelect, subQ, subQs, subgrpquestion, x, y;
  addSubQuestions = function(qn, srcSelect, chartid, callNumber, questions, destSelect) {
    var k, len, ref, results, squestion, triggerValue;
    ref = qn.triggerValues.triggerValue;
    results = [];
    for (k = 0, len = ref.length; k < len; k++) {
      triggerValue = ref[k];
      if (triggerValue.action.subQuestions != null) {
        results.push((function() {
          var l, len1, ref1, results1;
          ref1 = triggerValue.action.subQuestions.question;
          results1 = [];
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            squestion = ref1[l];
            srcSelect = processSubQuestionsForReport(squestion, srcSelect, chartid, callNumber, questions, destSelect);
            if (squestion.triggerValues != null) {
              results1.push(addSubQuestions(squestion, srcSelect, chartid, callNumber, questions, destSelect));
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      } else {
        results.push(void 0);
      }
    }
    return results;
  };
  qSelect = Number(document.getElementById("poiTypeReport").value);
  chartId = Number(document.getElementById("chart").value);
  srcSelect = document.getElementById("questionName");
  destSelect = document.getElementById("questionNameSelected");
  formId = document.getElementById("poiTypeReport").value;
  formModel = window.formCollection.findWhere({
    ref: formId
  });
  pages = [];
  pages = formModel.get("questionPage");
  if (formModel.get("type") === "TABLE") {
    pages = formModel.get("question");
  }
  page = [];
  if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
    x = 0;
    while (x < pages.length) {
      y = 0;
      while (y < pages[x].question.length) {
        pages[x].question[y]["page_number"] = x;
        page.push(pages[x].question[y]);
        y++;
      }
      x++;
    }
  } else if (formModel.get("type") === 'TABLE') {
    page = pages;
  }
  i = srcSelect.length;
  while (i >= 0) {
    srcSelect.remove(i);
    i--;
  }
  destSelect = document.getElementById("questionNameSelected");
  i = destSelect.length;
  while (i >= 0) {
    destSelect.remove(i);
    i--;
  }
  legendSelect = document.getElementById("legendQuestion");
  i = legendSelect.length;
  while (i >= 0) {
    legendSelect.remove(i);
    i--;
  }
  rowquestion = document.getElementById("rowquestion");
  i = rowquestion.length;
  while (i >= 0) {
    rowquestion.remove(i);
    i--;
  }
  subgrpquestion = document.getElementById("subgrpQuestion");
  i = subgrpquestion.length;
  while (i >= 0) {
    subgrpquestion.remove(i);
    i--;
  }
  criteriaquestion = document.getElementById("criteriaQuestion");
  i = criteriaquestion.length;
  while (i >= 0) {
    criteriaquestion.remove(i);
    i--;
  }
  legendSelect.add(new Option("Select One", ""), null);
  if (chartId === 1 || chartId === 2) {
    legendSelect.add(new Option("Day when updated", "modifiedday"), null);
    legendSelect.add(new Option("Week when updated", "modifiedweek"), null);
    legendSelect.add(new Option("Month when updated", "modifiedmonth"), null);
    legendSelect.add(new Option("Year  when updated", "modifiedyear"), null);
    legendSelect.add(new Option("Time of day when updated (24 hours)", "modifieddaytime"), null);
  }
  if (chartId === 0 || chartId === 1 || chartId === 2) {
    i = 0;
    if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE') {
      while (i < locationLabels.length) {
        if (locationLabels[i] !== null && locationLabels[i] !== "Location 1" && locationLabels[i] !== "Location 2" && locationLabels[i] !== "Location 3" && locationLabels[i] !== "Location 4" && locationLabels[i] !== "null") {
          if (chartId === 0) {
            legendSelect.add(new Option(locationLabels[i], i + 1), null);
          }
        } else {

        }
        i++;
      }
    }
    j = 0;
    while (j < page.length) {
      qn = page[j];
      if (qn.type === "IdQuestion" || qn.type === "PicturesQuestion" || qn.type === "Part_of_Question" || qn.type === "TimeQuestion" || qn.type === "TableQuestion" || qn.type === "Label" || qn.type === "HeaderQuestion" || qn.id === "phoneEditTime" || qn.id === "portalEditTime" || qn.id === "portalEditEntry" || qn.id === "Location1" || qn.id === "Location2" || qn.id === "Location3" || qn.id === "Location4" || qn.type === "GPSQuestion") {
        if (qn.id === "user_id") {

        } else {
          j++;
          continue;
        }
      } else {
        if ((qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "LikertScaleQuestion" || qn.type === "StatusQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0)) && chartId === 0 && !qn.inVisible) {
          legendSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
        }
        if (qn.type !== "NameQuestion") {
          if (qn.type !== "SkipQuestion") {
            if (chartId === 0 || chartId === 1 || chartId === 2) {
              if (((qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) || (qn.text === "Count" || qn.text === "count" || qn.id === "countQuestion")) {
                opt = new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id);
                $(opt).attr('isnumber', 'yes');
                if (questions !== "" && questions.indexOf(qn.id) !== -1) {
                  destSelect.add(opt, null);
                } else {
                  srcSelect.add(opt, null);
                }
              } else {
                opt = new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id);
                $(opt).attr('isnumber', 'no');
                if (questions !== "" && questions.indexOf(qn.id) !== -1) {
                  if ((qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "LikertScaleQuestion" || qn.type === "StatusQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0) || qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) {
                    destSelect.add(opt, null);
                  }
                } else {
                  if ((qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "LikertScaleQuestion" || qn.type === "StatusQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0) || qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) {
                    srcSelect.add(opt, null);
                  }
                }
              }
            } else {
              if (questions !== "" && questions.indexOf(qn.id) !== -1) {
                if ((qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "LikertScaleQuestion" || qn.type === "StatusQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0) || qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) {
                  destSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
                }
              } else {
                if ((qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "LikertScaleQuestion" || qn.type === "StatusQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0) || qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) {
                  srcSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
                }
              }
            }
          }
          if ((qn.triggerValues != null) && !qn.inVisible) {
            addSubQuestions(qn, srcSelect, chartId, 1, questions, destSelect);
          }
        }
      }
      j++;
    }
  }
  if (chartId === 3) {
    legendSelect.add(new Option("Select one", ""), null);
    i = 0;
    j = 0;
    while (j < page.length) {
      qn = page[j];
      if (qn.inVisible || qn.type === "IdQuestion" || qn.type === "PicturesQuestion" || qn.type === "Part_of_Question" || qn.type === "TimeQuestion" || qn.type === "TableQuestion" || qn.type === "Label" || qn.type === "HeaderQuestion" || qn.id === "phoneEditTime" || qn.id === "portalEditTime" || qn.id === "portalEditEntry" || qn.id === "Location1" || qn.id === "Location2" || qn.id === "Location3" || qn.id === "Location4" || qn.type === "GPSQuestion" || qn.type === "ValidationRuleQuestion" || qn.type === "FileQuestion" || qn.type === "SummaryTableQuestion") {
        j++;
        continue;
      } else {
        if (qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "SkipQuestion" || qn.type === "LikertScaleQuestion" || qn.type === "StatusQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0)) {
          if (questions !== "" && questions.indexOf(qn.id) !== -1) {
            if (qn.type !== "SkipQuestion") {
              destSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
            }
          } else {
            if (qn.type !== "SkipQuestion") {
              srcSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
            }
          }
          if (qn.triggerValues != null) {
            addSubQuestions(qn, srcSelect, chartId, 1, questions, destSelect);
          }
        }
      }
      j++;
    }
  }
  if (chartId === -1 || chartId === -2) {
    destSelect = document.getElementById("questionNameSelected");
    i = destSelect.length;
    while (i >= 0) {
      destSelect.remove(i);
      i--;
    }
    legendSelect = document.getElementById("legendQuestion");
    i = legendSelect.length;
    while (i >= 0) {
      legendSelect.remove(i);
      i--;
    }
    legendSelect.add(new Option("Select One", ""), null);
    if (chartId === -1 && formModel.get("type") !== 'TABLE') {
      legendSelect.add(new Option("User", "user_id"), null);
    }
    if (chartId === -1 && formModel.get("isChild")) {
      legendSelect.add(new Option("Parent form name", "parent_name"), null);
    }
    if (chartId === -1 && formModel.get("type") === "TABLE") {
      legendSelect.add(new Option("Parent Location Level 1", "parent_location1"), null);
      legendSelect.add(new Option("Parent Location Level 2", "parent_location2"), null);
      legendSelect.add(new Option("Parent Location Level 3", "parent_location3"), null);
      legendSelect.add(new Option("Parent Location Level 4", "parent_location4"), null);
    }
    rowquestion = document.getElementById("rowquestion");
    i = rowquestion.length;
    while (i >= 0) {
      rowquestion.remove(i);
      i--;
    }
    subgrpquestion.add(new Option("Select One", ""), null);
    criteriaquestion.add(new Option("Select One", ""), null);
    if (chartId === -1) {
      $("#includelocation").show();
      $("#includelocationnewdatarow").show();
      $("#criteriarow").show();
    } else {
      $("#includelocation").hide();
      $("#includelocationnewdatarow").hide();
      $("#subgrouprow").hide();
      $("#criteriarow").hide();
    }
    i = 0;
    if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE') {
      while (i < locationLabels.length) {
        if (locationLabels[i] !== null && locationLabels[i] !== "Location 1" && locationLabels[i] !== "Location 2" && locationLabels[i] !== "Location 3" && locationLabels[i] !== "Location 4" && locationLabels[i] !== "null") {
          legendSelect.add(new Option(locationLabels[i], i + 1), null);
          rowquestion.add(new Option(locationLabels[i], i + 1), null);
          subgrpquestion.add(new Option(locationLabels[i], i + 1), null);
        }
        i++;
      }
    }
    j = 0;
    while (j < page.length) {
      qn = page[j];
      if (qn.inVisible || qn.type === "IdQuestion" || qn.type === "PicturesQuestion" || qn.type === "Part_of_Question" || qn.type === "TimeQuestion" || qn.type === "TableQuestion" || qn.type === "Label" || qn.type === "HeaderQuestion" || qn.type === "ValidationRuleQuestion" || qn.type === "FileQuestion" || qn.type === "SummaryTableQuestion") {
        if (qn.id === "phoneEditTime" || qn.id === "portalEditTime") {

        } else {
          j++;
          continue;
        }
      }
      if (qn.id === "Location1" || qn.id === "Location2" || qn.id === "Location3" || qn.id === "Location4") {
        j++;
        continue;
      }
      if (chartId === -1 && qn.type === "NameQuestion") {
        legendSelect.add(new Option(qn.text, qn.id), null);
      }
      if (chartId === -2) {
        if (questions !== "" && questions.indexOf(qn.id) !== -1) {
          if ((qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) {
            destSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
          }
        } else {
          if ((qn.type === "IntQuestion" || qn.type === "FloatQuestion" || (qn.type === "CalculatedValueQuestion" && qn.numericOnly === true)) && !qn.inVisible) {
            srcSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
          }
        }
      } else {
        if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
          page_no = "-(Page_" + Number(qn.page_number + 1) + ")";
        } else {
          page_no = "";
        }
        if (qn.type !== "SkipQuestion" && qn.type !== "DigitalSignatureQuestion") {
          if (questions !== "" && questions.indexOf(qn.id) !== -1) {
            destSelect.add(new Option(qn.text + page_no, qn.id), null);
          } else {
            srcSelect.add(new Option(qn.text + page_no, qn.id), null);
          }
        }
      }
      if (qn.triggerValues != null) {
        addSubQuestions(qn, srcSelect, chartId, 1, questions, destSelect);
      }
      if (qn.type === "IdQuestion" || qn.type === "PicturesQuestion" || qn.type === "Part_of_Question" || qn.type === "TimeQuestion" || qn.type === "TableQuestion" || qn.type === "Label" || qn.type === "HeaderQuestion" || qn.id === "phoneEditTime" || qn.id === "portalEditTime" || qn.id === "portalEditEntry" || qn.type === "GPSQuestion" || qn.type === "ValidationRuleQuestion" || qn.type === "FileQuestion") {
        if (qn.id === "user_id") {

        } else {
          j++;
          continue;
        }
      } else {
        if (qn.type === "BooleanQuestion" || qn.type === "SelectOneQuestion" || qn.type === "SelectMultipleQuestion" || qn.type === "SkipQuestion" || qn.type === "StatusQuestion" || qn.type === "LikertScaleQuestion" || ((qn.validationlist != null) && qn.validationlist.length > 0)) {
          if (qn.triggerValues) {
            if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
              if (qn.type !== "SkipQuestion") {
                legendSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                rowquestion.add(new Option(qn.text + " -(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                subgrpquestion.add(new Option(qn.text + " -(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type === "CalculatedValueQuestion" || qn.type === "StringQuestion" || qn.type === "BooleanQuestion") {
                criteriaquestion.add(new Option(qn.text + " -(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
            } else {
              if (qn.type !== "SkipQuestion") {
                legendSelect.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                rowquestion.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                subgrpquestion.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type === "CalculatedValueQuestion" || qn.type === "StringQuestion" || qn.type === "BooleanQuestion") {
                criteriaquestion.add(new Option(qn.text, qn.id), null);
              }
            }
            ref = qn.triggerValues.triggerValue;
            for (index = k = 0, len = ref.length; k < len; index = ++k) {
              subQ = ref[index];
              if (qn.triggerValues.triggerValue[index].action.subQuestions !== undefined) {
                newSq = qn.triggerValues.triggerValue[index].action.subQuestions.question;
                for (index2 = l = 0, len1 = newSq.length; l < len1; index2 = ++l) {
                  subQs = newSq[index2];
                  if (subQs.text !== undefined) {
                    if ((chartId === -2 && (subQs.type === "BooleanQuestion" || subQs.type === "SelectOneQuestion" || subQs.type === "LikertScaleQuestion" || subQs.type === "SelectMultipleQuestion" || subQs.type === "StatusQuestion" || ((subQs.validationlist != null) && subQs.validationlist.length > 0))) || chartId === -1) {
                      legendSelect.add(new Option(subQs.text + "-(Page_" + Number(qn.page_number + 1) + ")", subQs.id), null);
                      legendSelect.options[legendSelect.options.length - 1].innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;" + legendSelect.options[legendSelect.options.length - 1].innerHTML;
                      rowquestion.add(new Option(subQs.text + "-(Page_" + Number(qn.page_number + 1) + ")", subQs.id), null);
                      rowquestion.options[rowquestion.options.length - 1].innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;" + rowquestion.options[rowquestion.options.length - 1].innerHTML;
                    }
                  }
                }
              }
            }
          } else {
            if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
              if (qn.type !== "SkipQuestion") {
                legendSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                rowquestion.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                subgrpquestion.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
            } else {
              if (qn.type !== "SkipQuestion") {
                legendSelect.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                rowquestion.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type !== "SkipQuestion") {
                subgrpquestion.add(new Option(qn.text, qn.id), null);
              }
            }
          }
        } else {
          if (chartId === -1) {
            if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
              if (qn.type !== "SkipQuestion") {
                subgrpquestion.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type === "CalculatedValueQuestion" || qn.type === "StringQuestion" || qn.type === "BooleanQuestion") {
                criteriaquestion.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
            } else {
              if (qn.type !== "SkipQuestion") {
                subgrpquestion.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type === "CalculatedValueQuestion" || qn.type === "StringQuestion" || qn.type === "BooleanQuestion") {
                criteriaquestion.add(new Option(qn.text, qn.id), null);
              }
            }
          }
          if (chartId === -2) {
            if (formModel.get("type") === 'POI' || formModel.get("type") === 'AREA' || formModel.get("type") === 'ROUTE' || formModel.get("type") === 'TASKFORM') {
              if (qn.type === "CalculatedValueQuestion" && qn.numericOnly !== true) {
                legendSelect.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
              if (qn.type === "CalculatedValueQuestion" && qn.numericOnly !== true) {
                rowquestion.add(new Option(qn.text + "-(Page_" + Number(qn.page_number + 1) + ")", qn.id), null);
              }
            } else {
              if (qn.type === "CalculatedValueQuestion" && qn.numericOnly !== true) {
                legendSelect.add(new Option(qn.text, qn.id), null);
              }
              if (qn.type === "CalculatedValueQuestion" && qn.numericOnly !== true) {
                rowquestion.add(new Option(qn.text, qn.id), null);
              }
            }
          }
        }
      }
      j++;
    }
    j = 0;
  }
  changedColumnQuestion();
  if (chartId === -1) {
    $("#yaxisrow").show();
    $("#type").val('SUM');
    $('select option[value=PERCENT]').attr('disabled', 'disabled').hide();
    $('select option[value=NONE]').removeAttr('disabled').show();
  } else if (chartId === -2) {
    $("#yaxisrow").show();
    $("#type").val('SUM');
    $('select option[value=PERCENT]').removeAttr('disabled').show();
    $('select option[value=NONE]').attr('disabled', 'disabled').hide();
  } else {
    $("#yaxisrow").hide();
  }
  if (chartId === 0) {
    $("#orientationrow").show();
  } else {
    $("#orientationrow").hide();
  }
  document.getElementById("excludenull").checked = false;
  document.getElementById("editorFilterType").checked = false;
  document.getElementById("dateFilterType").checked = false;
  document.getElementById("locFilterType").checked = false;
  if (chartId === 3) {
    $("#yaxisrow").hide();
    $("#legendrow").hide();
    $("#numericfieldsrow").hide();
    $("#chartingTable").show();
    $("#subgrouprow").hide();
    $("#criteriarow").hide();
  } else if (chartId === -1) {
    $("#yaxisrow").hide();
    $("#legendrow").show();
    $("#numericfieldsrow").hide();
    $("#chartingTable").hide();
    $("#criteriarow").show();
  } else if (chartId === 2) {
    $("#chartingTable").show();
    $("#numericfieldsrow").show();
    $("#yaxisrow").hide();
    $("#legendrow").show();
    $("#numericfieldsrow").show();
    $("#subgrouprow").hide();
    $("#criteriarow").hide();
  } else {
    $("#legendrow").show();
    $("#numericfieldsrow").show();
    $("#subgrouprow").hide();
    $("#criteriarow").hide();
  }
  if (chartId === 0 || chartId === 1 || chartId === 2 || chartId === 3) {
    $("#includelocation").hide();
    $("#newdata").hide();
    $("#includeUsers").hide();
    $("#includelocationnewdatarow").hide();
    $("#chartingTable").show();
    $("#excludenonresponse").show();
    document.getElementById("includelocation").checked = false;
    document.getElementById("combinenumericfields").checked = false;
    document.getElementById("locationreport").checked = false;
    document.getElementById("rowquestion").value = "";
    if (chartId === 3 || chartId === 2 || chartId === 1 || chartId === 0) {
      document.getElementById("legendQuestion").value = "";
      if (chartId === 3) {
        $("#legendrow").hide();
      }
      levels = document.getElementById("locationLevel");
      i = levels.length;
      while (i >= 0) {
        levels.remove(i);
        i--;
      }
      i = 0;
      while (i < locationLabels.length) {
        if (locationLabels[i] !== null && locationLabels[i] !== "Location 1" && locationLabels[i] !== "Location 2" && locationLabels[i] !== "Location 3" && locationLabels[i] !== "Location 4" && locationLabels[i] !== "null") {
          levels.add(new Option(locationLabels[i], i + 1), null);
        } else {

        }
        i++;
      }
    } else {
      $("#legendrow").show();
      $("#yaxisrow").hide();
      $("#tablegrouplabel").hide();
      $("#tablegrouplabel2").hide();
      $("#chartgrouplabel").show();
      $("#numericfieldsrow").hide();
      $("#chartingTable").hide();
      $("#rowgroup").hide();
    }
    if (chartId === 0 || chartId === 1 || chartId === 2) {
      $("#chartgrouplabel").show();
      $("#tablegrouplabel2").hide();
      $("#tablegrouplabel").hide();
    }
  } else {
    $("#chartingTable").hide();
    $("#numericfieldsrow").hide();
    $("#includelocation").show();
    $("#newdata").show();
    $("#includeUsers").show();
    $("#includelocationnewdatarow").show();
    $("#excludenonresponse").hide();
    document.getElementById("includelocation").checked = false;
    changedColumnQuestion();
    document.getElementById("legendQuestion").value = "";
    document.getElementById("rowquestion").value = "";
    $("#yaxisrow").show();
    $("#chartgrouplabel").hide();
    if (chartId === -2) {
      $("#tablegrouplabel2").show();
      $("#tablegrouplabel").hide();
      $("#includelocationnewdatarow").hide();
      $("#noneoption").hide();
      $("#rowgroup").show();
      document.getElementById("rowquestion").disabled = true;
    } else {
      $("#tablegrouplabel2").hide();
      $("#tablegrouplabel").show();
      $("#noneoption").show();
      $("#rowgroup").hide();
    }
  }
  reportType = (document.getElementById("locationreport").checked ? 1 : 0);
  if (reportType === 1) {
    document.getElementById("locationLevel").disabled = false;
  } else {
    document.getElementById("locationLevel").disabled = true;
  }
  if (formModel.get("type") !== 'POI' && formModel.get("type") !== 'AREA' && formModel.get("type") !== 'ROUTE') {
    $('#chartingTable').hide();
    return $("#locationreport").attr("checked", false);
  }
};

handleError = function(response) {
  var result;
  result = JSON.parse(response.responseText);
  if (result && result.errorCode !== undefined && (result.errorCode === "1009" || result.errorCode === "1004" || result.errorCode === "1007")) {
    return Logout();
  }
};

toggleLegendTable = function(show) {
  if (show === 1) {
    $("#legendrow").show();
    $("#rowgroup").show();
    $("#yaxisrow").show();
    $("#numericfieldsrow").show();
    return $("#chartingTable").show();
  } else {
    $("#legendrow").hide();
    $("#rowgroup").hide();
    $("#yaxisrow").hide();
    $("#numericfieldsrow").hide();
    return $("#chartingTable").hide();
  }
};


/*
    Clears the date fields
 */

clearDates = function() {
  $("#from").val("");
  $("#from").trigger("change");
  $("#to").val("");
  return $("#to").trigger("change");
};

imageSelected = function(rowCount) {
  var file;
  return file = document.getElementById("add_image" + rowCount).files[0];
};


/*
deletePOI deletes a poi
arguments
id - the form that the answer to be deleted belongs to
row_id - id of the answer in history
uuid -- unique identifier of all the answers of his answer in history
 */

deletePOI = function(id, row_id, uuid) {
  return bootbox.confirm("Are you sure you want to delete this POI?", function(result) {
    var model;
    if (result) {
      model = answerCollection.get(uuid);
      if (model != null) {
        model.destroy();
        bootbox.alert("POI deleted");
        goBack(true);
        answerCollection.remove(model);
        updateCurrentSelection();
      } else {
        model = abv.tasksCollection.get(uuid);
        model.destroy();
        bootbox.alert("POI deleted");
        goBack(true);
        abv.tasksCollection.remove(model);
        updateCurrentSelection();
      }
      if (!$("#feedviewButton").hasClass('active')) {
        return mapView.draw();
      }
    }
  });
};

setEditableTableQuestion = function(question) {
  var buttons, cont, element5, i, id, instance, j, k, l, len, len1, objPOI, qn, questions, ref, results, row, rowCount, rows, rowsLength, table, x;
  id = getPOIId(question.table.columns.ref);
  objPOI = getPOIByID(id);
  instance = objPOI.instance;
  if (tableRows[objPOI.identifier] === undefined || tableRows[objPOI.identifier].length === 0) {
    document.getElementById(id + "_toparea").innerHTML = "<b>" + objPOI.name + "</b>  <a class='btn btn-default btn-sm' id='editButton" + objPOI.id + "' onclick='addRow(" + id + ")'>Add row</a>";
  }
  rows = instance.rows;
  rowsLength = rows.length;
  questions = instance.questions;
  table = document.getElementById("tab" + id);
  rowCount = table.rows.length;
  cont = true;
  i = 0;
  ref = table.rows;
  results = [];
  for (i = k = 0, len = ref.length; k < len; i = ++k) {
    row = ref[i];
    j = 0;
    for (j = l = 0, len1 = questions.length; l < len1; j = ++l) {
      qn = questions[j];
      qn = questions[j];
      if (!qn.inVisible) {
        if ((row != null) && (tableRows[objPOI.identifier] == null) || tableRows[objPOI.identifier].length === 0) {
          if (j === row.cells.length - 3 && i !== 0) {
            element5 = document.createElement("input");
            element5.type = "button";
            element5.value = "remove";
            element5.setAttribute("onclick", "deleteRow(" + i + ", " + id + ")");
            element5.setAttribute("name", i);
            row.cells[j + 2].appendChild(element5);
          }
        }
        if (qn.type === "SelectOneQuestion") {
          buttons = document.getElementsByName(qn.id + "" + i);
          x = 0;
          while (x < buttons.length) {
            buttons[x].disabled = false;
            x++;
          }
        } else if ((qn.validationlist != null) && qn.validationlist.length > 0) {
          if (document.getElementById(id + qn.id + "" + i) != null) {
            document.getElementById(id + qn.id + "" + i).disabled = false;
          }
        } else {
          if (document.getElementById(id + qn.id + "" + i) != null) {
            document.getElementById(id + qn.id + "" + i).readOnly = false;
          } else {
            cont = false;
          }
        }
      }
    }
    if (!cont) {
      break;
    } else {
      results.push(void 0);
    }
  }
  return results;
};

addRow = function(id) {
  var br, cell1, cell2, cell5, el, element2, element5, j, k, label, len, list, objPOI, qn, ref, row, rowCount, select, table, x;
  table = document.getElementById("tab" + id);
  objPOI = getPOIByID(id);
  rowCount = table.rows.length;
  row = table.insertRow(rowCount);
  row.setAttribute("class", "alt4");
  cell1 = row.insertCell(0);
  cell1.setAttribute("class", "lft");
  label = document.createElement("b");
  label.innerHTML = rowCount;
  cell1.appendChild(label);
  j = 1;
  ref = objPOI.instance.questions;
  for (k = 0, len = ref.length; k < len; k++) {
    qn = ref[k];
    if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
      continue;
    }
    cell2 = row.insertCell(j);
    element2 = document.createElement("input");
    if (qn.type === "SelectOneQuestion") {
      x = 0;
      while (x < qn.options.length) {
        el = document.createElement("input");
        el.type = "radio";
        el.value = qn.options[x];
        el.name = qn.id + "" + (rowCount - 1);
        el.id = id + qn.id + "" + (rowCount - 1);
        cell2.appendChild(el);
        el = document.createElement("label");
        el.innerHTML = qn.options[x];
        cell2.appendChild(el);
        br = document.createElement("br");
        cell2.appendChild(br);
        x++;
      }
    } else if ((qn.validationlist != null) && qn.validationlist.length > 0) {
      select = document.createElement("select");
      select.name = id + qn;
      select.id = id + qn.id + "" + (rowCount - 1);
      el = document.createElement("option");
      el.value = "";
      el.innerHTML = "";
      select.add(el);
      x = 0;
      list = qn.validationlist;
      while (x < list.length) {
        el = document.createElement("option");
        el.value = list[x];
        el.innerHTML = list[x];
        select.add(el);
        x++;
      }
      cell2.appendChild(select);
    } else {
      if (qn.type === "DateQuestion") {
        element2.type = "date";
      } else {
        element2.type = "text";
      }
      element2.setAttribute("id", id + qn.id + "" + (rowCount - 1));
      element2.setAttribute("name", id + qn.id);
      cell2.appendChild(element2);
    }
    j++;
  }
  cell5 = row.insertCell(j);
  element5 = document.createElement("input");
  element5.type = "button";
  element5.value = "remove";
  element5.setAttribute("onclick", "deleteRow(" + rowCount + ", " + id + ")");
  element5.setAttribute("name", rowCount);
  return cell5.appendChild(element5);
};

getQuestionValue = function(question) {
  var actions, optlength, opts, q, qn, sq, t, value;
  opts = question.options;
  actions = question.action;
  optlength = 0;
  optlength = opts.length;
  t = 0;
  while (t < optlength) {
    if ((actions[opts[t]] != null) && opts[t] !== value) {
      sq = actions[opts[t]];
      q = 0;
      while (q < sq.length) {
        value = "NULL";
        qn = sq[q];
        if (qn.type === "IntQuestion") {
          value = "0";
        }
        if (qn.type === "Label" || qn.type === "HeaderQuestion") {
          continue;
        }
        if ((qn.value != null) && qn.value !== "") {
          value = qn.value;
        }
        jsontextsubq += "\"" + qn.id + "\":\"" + value + "\",";
        getQuestionValue(qn);
        q++;
      }
      hideSubQuestions(question.id + "_" + removeSpace(trim1(opts[t])));
    }
    t++;
  }
  return jsontextsubq;
};

getQuestionValues = function() {
  var i, instance, j, jsonText, page, question, questionID, value, z;
  instance = POI[current_id].instance;
  jsonText = "{\"answerTable\" : \"" + POI[current_id].answerTable + "\",";
  i = 0;
  z = 0;
  while (i < instance.pages.length) {
    page = instance.pages[i];
    j = 0;
    while (j < page.questions.length) {
      question = page.questions[j];
      if (question.id === "ID") {
        questionID = question.value;
      }
      if (!(question.type === "PicturesQuestion" || question.id === "syncconflict" || question.type === "Label" || question.type === "HeaderQuestion")) {
        value = "NULL";
        if (question.type === "IntQuestion") {
          value = "0";
        }
        if (question.id === "portalEditTime") {
          question.value = portalEditTime;
          value = portalEditTime;
        }
        if (question.id === "portalEditEntry") {
          question.value = portalEditEntryTime.getTime();
          value = portalEditEntryTime.getTime();
        }
        if (question.value !== undefined && question.value !== "" && typeof question.value === "string") {
          value = question.value;
          value = value.replace("\\", "\\\\");
        } else {
          value = question.value;
        }
        if (question.id === "countQuestion") {
          value = 1;
        }
        if ((value == null) || value === "") {
          value = "NULL";
        }
        if (question.type === "IntQuestion" && value === "NULL") {
          value = 0;
        }
        if (z === 0) {
          if (question.id !== "user_id" && question.id !== "group_id" && question.id !== "modified" && question.type !== "TableQuestion" && question.type !== "Part_of_Question") {
            jsonText += "\"" + question.id + "\":\"" + value + "\",";
          }
          jsontextsubq = '';
        } else {
          if (getQuestionValue(question) === "") {
            if (question.id !== "user_id" && question.id !== "group_id" && question.id !== "modified" && question.type !== "TableQuestion" && question.type !== "Part_of_Question") {
              jsonText += "\"" + question.id + "\":\"" + value + "\",";
            }
          } else {
            if (question.id !== "user_id" && question.id !== "group_id" && question.id !== "modified" && question.type !== "TableQuestion" && question.type !== "Part_of_Question") {
              jsonText += "\"" + question.id + "\":\"" + value + "\",";
              jsonText += jsontextsubq;
            }
            jsontextsubq = '';
          }
        }
        z++;
      }
      j++;
    }
    i++;
  }
  return jsonText;
};

saveTableInstance = function(question) {
  var cont, i, id, ids, instance, j, k, l, len, len1, objPOI, qn, questions, ref, relId, results, row, rowCount, rows, rowsLength, table, tempInstance, value;
  id = getPOIId(question.table.columns.ref);
  relId = question.table.columns.id;
  objPOI = getPOIByID(id);
  instance = objPOI.instance;
  instance.temp = new Array();
  table = document.getElementById('tab' + id);
  rowCount = table.rows.length;
  rows = instance.rows;
  rowsLength = rows.length;
  questions = instance.questions;
  ids = [];
  ids.push(id);
  ids.push(relId);
  uploadTables.push(ids);
  if (rowsLength <= 0) {
    cont = true;
    ref = table.rows;
    results = [];
    for (i = k = 0, len = ref.length; k < len; i = ++k) {
      row = ref[i];
      if (i === (rowCount - 1)) {
        continue;
      }
      tempInstance = new Instance();
      for (j = l = 0, len1 = questions.length; l < len1; j = ++l) {
        question = questions[j];
        qn = new Questions();
        qn.id = questions[j].id;
        qn.inVisible = questions[j].inVisible;
        qn.type = questions[j].type;
        if (qn.id === 'ID') {
          tempInstance.questions.push(qn);
          continue;
        }
        if (qn.inVisible) {
          continue;
        }
        if (qn.type === "SelectOneQuestion") {
          if (document.getElementsByName(qn.id + "" + i) != null) {
            value = getRadioButtonValue(qn.id + "" + i);
            qn.value = value;
            tempInstance.questions.push(qn);
            continue;
          } else {

          }
        }
        if (document.getElementById(id + qn.id + '' + i) != null) {
          value = document.getElementById(id + qn.id + '' + i).value;
          qn.value = value;
          tempInstance.questions.push(qn);
        } else {
          cont = false;
        }
      }
      results.push(instance.temp.push(tempInstance));
    }
    return results;
  }
};

activateLicensekey = function() {
  var cryptoLine, license;
  cryptoLine = $('#licensekey').val().split('\n');
  license = {};
  license["license"] = $('#licensekey').val();
  showProgress();
  return $.ajax({
    type: "POST",
    data: JSON.stringify(license),
    url: baseUrl + "app/data/activatelicensekey",
    headers: {
      userid: userName,
      key: pwrd,
      "Content-Type": "application/json"
    },
    success: function(result) {
      return result;
    },
    complete: function() {
      return closeProgress();
    }
  });
};

//# sourceMappingURL=maps/utilities.js.map
